/**
=========================================================
* Iris Design Limited  Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.irisdesignlimited.com/product/material-dashboard-react
* Copyright 2023 Dev Iris Design Limited Company (https://www.irisdesignlimited.com)

Coded by www.irisdesignlimited.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import ArrowCircleRightTwoToneIcon from '@mui/icons-material/ArrowCircleRightTwoTone';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NoteCell from 'examples/NoteCell';
import SizeHtml from 'components/SizeHtml';
import TrackingCell from 'examples/TrackingCell';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import Card from "@mui/material/Card";
// Using HTML components instead
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { fontSize, styled } from '@mui/system';
// Using pure HTML instead of components
import MDPageBar from 'components/MDPagination/MDPageBar';
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import NoteDialog from 'examples/NoteDialog';
import HTMLDataTable from "examples/Tables/HTMLDataTable";
import { editOrder, ffbeeful, ffburgerprints, ffa2k, ffflashship, ffmango, ffmerchfox, ffmerchize, ffluxurypro, ffanprint, ffpabeeful, ffprintik, ffprintway, getOrders, bulkUpdateOrders } from "features/slices";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import CheckIcon from '@mui/icons-material/Check';
import bcrypt from 'bcryptjs';
import { NotificationManager } from "react-notifications";
import { useDispatch, useSelector } from "react-redux";
import beeful from "./beeful";
import mango from './mango';
import merchfox from "./merchfox";
import merchfoxManual from "./merchfoxManual";
import teecraft from "./teecraft";
import { updateCurrentPage } from 'features/slices';
import { ffteecraft } from 'features/slices';
import printik from './printik';
import apbeeful from './apbeeful';
import luxurypro from './luxurypro';
import merchize from './merchize';
import anprint from './anprint';
import flashship from './flashship';
import OrderHistoryDialog, { OrderHistoryButton } from './OrderHistoryDialog';
import LuxuryProCatalogPicker from './LuxuryProCatalogPicker';
import LuxuryProOptionPicker from './LuxuryProOptionPicker';
import AnprintCatalogPicker from './AnprintCatalogPicker';
import AnprintVariantPicker from './AnprintVariantPicker';
import {
  orderHasDesignForFulfill,
  orderHasDesignForLuxuryPro,
  fieldMatches,
  parseOrderSizeColor,
  previewLuxuryProNote,
  resolveLuxuryPro,
} from './luxuryproFulfill';
import { resolveAnprint, autoResolveAnprint, flattenAnprintVariants, resolveAnprintFromVariant } from './anprintFulfill';
import { colorsForSize, findBurgerprintsVariant, matchBurgerprintsOption, suggestBurgerprintsShortCode } from './burgerprintsFulfill';
import { detectA2kProductCode, matchA2kColor, matchA2kVariant } from './a2kFulfill';
import { GET } from "../../api";
import { resolveMerchize } from './merchizeFulfill';
import { isOrdersViewAccount } from "utils/access";
const anprintVariants = flattenAnprintVariants(anprint);
const Section = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1),
}));

const GreenSection = styled(Section)({
});

const BlueSection = styled(Section)({
  background: 'linear-gradient(195deg, #9dbdba, #9dbdba)',
  width: "100%",
  display: "flex",
  flexDirection: "row"
});

const DarkSection = styled(Section)({
  background: 'linear-gradient(195deg, #42424a, #191919)',
});

const CaptionText = styled('p')({
  display: "flex",
  flexDirection: "row",
  fontWeight: 'bold',
  marginTop: 4,
  fontSize: "14px",
  color: "#1E293B",
});

const CaptionText2 = styled('p')({
  fontWeight: 'bold',
  marginTop: 4,
  color: "white",
  fontSize: "14px",
});

const InfoText = styled('span')({
  marginLeft: 5,
  color: "#1E293B"
});

const NormalText = styled('span')({
  fontWeight: '400',
  marginLeft: 5,
  color: 'inherit',
});

const HighlightedText = styled('span')({
  fontWeight: '500',
  color: 'orange',
  marginLeft: 5,
  fontSize: "14px"

});

const RedText = styled('span')({
  color: 'red',
  fontWeight: 'bold',
});
const ffSite = ["Merchfox", "Mango", "Beeful", "PA-Beeful", "Printify", "Printway", "Burgershop", "Printik", "LuxuryPro", "Anprint", "Flashship", "Merchize", "BurgerPrints", "A2K"]
const legacyVariantFactories = ["Merchfox", "Mango", "Beeful", "PA-Beeful", "Printik", "Teecraft"];
const flashshipOptionKeys = [
  { key: 'product_type', label: 'Product' },
  { key: 'brand', label: 'Brand' },
  { key: 'style', label: 'Style' },
  { key: 'size', label: 'Size' },
  { key: 'color', label: 'Color' },
];
const FLASHSHIP_DEFAULT_PRINT_TYPE = 2;
const flashshipPrintTypeOptions = [
  { value: 1, label: 'Standard DTF' },
  { value: 2, label: 'Premium DTG' },
  { value: 3, label: 'Basic DTF' },
];

function Tables() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.user.data || []);
  const permission = useSelector((state) => state.user.permission || []);
  const admin = useSelector((state) => state.user.admin === true);
  const readOnly = isOrdersViewAccount(admin, permission);
  const can = (key) => !readOnly && permission.includes(key);
  const startDate = useSelector((state) => state.user.startDate);
  const type = useSelector((state) => state.user.type);
  const filterStore = useSelector((state) => state.user.filterStore);
  const order_status = useSelector((state) => state.user.order_status);
  const endDate = useSelector((state) => state.user.endDate);
  const user = useSelector((state) => state.user.user);
  const search = useSelector((state) => state.user.search);
  const currentPage = useSelector((state) => state.user.currentPage) || 1
  const flashshipVariants = flashship || [];

  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [open8, setOpen8] = useState(false);
  const [clear, setClear] = useState("");
  const [color, setColor] = useState("");
  const [size, setSize] = useState("");
  const [itemEditor, setItemEditor] = useState({})
  const [tracking, setTracking] = useState("");
  const [fulfil, setFulfil] = useState("");
  const [lineship, setLineship] = useState("");
  const [note, setNote] = useState("");
  const [basecost, setBasecost] = useState("");
  const [ff, setFf] = useState("Merchfox");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedOrderItems, setSelectedOrderItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [historyItem, setHistoryItem] = useState(null);
  const [openBulkDialog, setOpenBulkDialog] = useState(false);
  const [bulkFF, setBulkFF] = useState("");
  const [bulkStatusFulfil, setBulkStatusFulfil] = useState(false);
  const [openShippingDialog, setOpenShippingDialog] = useState(false);
  const [shippingMethod, setShippingMethod] = useState("");
  const [luxuryProSel, setLuxuryProSel] = useState({});
  const [merchizeSel, setMerchizeSel] = useState({});
  const [anprintSel, setAnprintSel] = useState({});
  const [flashshipSel, setFlashshipSel] = useState({});
  const [flashshipPicks, setFlashshipPicks] = useState({});
  const [legacyVariantPicks, setLegacyVariantPicks] = useState({});
  const [burgerprintsProducts, setBurgerprintsProducts] = useState([]);
  const [burgerprintsDetails, setBurgerprintsDetails] = useState({});
  const [burgerprintsSel, setBurgerprintsSel] = useState({});
  const [a2kProducts, setA2kProducts] = useState([]);
  const [a2kDetails, setA2kDetails] = useState({});
  const [a2kSel, setA2kSel] = useState({});

  useEffect(() => {
    if (ff !== 'BurgerPrints' || burgerprintsProducts.length) return undefined;
    let cancelled = false;
    GET('/burgerprints-products')
      .then((res) => {
        if (cancelled) return;
        const products = (res?.data?.products || []).map((product) => ({
          ...product,
          name: product.short_code ? `${product.name} (${product.short_code})` : product.name,
        }));
        setBurgerprintsProducts(products);
        if (!products.length) {
          NotificationManager.error(res?.data?.message || 'Không tải được catalog BurgerPrints', 'Error', 2500);
        }
      })
      .catch(() => {
        if (!cancelled) NotificationManager.error('Không tải được catalog BurgerPrints', 'Error', 2500);
      });
    return () => {
      cancelled = true;
    };
  }, [ff, burgerprintsProducts.length]);

  useEffect(() => {
    if (ff !== 'A2K' || a2kProducts.length) return undefined;
    let cancelled = false;
    GET('/a2k-products')
      .then((res) => {
        if (cancelled) return;
        const products = (res?.data?.products || []).map((product) => ({
          ...product,
          name: product.product_code ? `${product.name} (${product.product_code})` : product.name,
        }));
        setA2kProducts(products);
        if (!products.length) {
          NotificationManager.error(res?.data?.message || 'Không tải được catalog A2K', 'Error', 2500);
        }
      })
      .catch(() => {
        if (!cancelled) NotificationManager.error('Không tải được catalog A2K', 'Error', 2500);
      });
    return () => {
      cancelled = true;
    };
  }, [ff, a2kProducts.length]);

  const hasFulfillDesign = (item, side) => {
    const v = item?.design_link?.[side];
    return v != null && String(v).trim() !== '';
  };

  const renderFulfillDesignThumb = (item, side) => {
    const url = item?.design_link?.[side];
    if (!url || String(url).trim() === '') return null;
    if (url === 'upload') {
      return <span className="caption-text" style={{ fontSize: '10px', margin: 5, color: '#ff9800' }}>{side}: Uploading</span>;
    }
    const label = side === 'front' ? 'Front' : 'Back';
    return (
      <>
        <span className="caption-text" style={{ fontSize: '10px', margin: 5 }}>{label}:</span>
        <a href={url} target="_blank" rel="noopener noreferrer">
          <img src={url} style={{ height: '70px' }} alt={label} />
        </a>
      </>
    );
  };

  function modifyUrlString(inputString) {
    if (inputString.includes("/cdn-cgi")) {
      const regex = /https:\/\//g;
      const matches = inputString.match(regex);
      if (!matches) {
        return inputString;
      } else if (matches.length === 1) {
        return 'https://' + inputString.split('https://')[1]
      } else if (matches.length === 2) {
        const parts = inputString.split('https://');
        return 'https://' + parts[2];
      } else {
        return inputString;
      }
    } else {
      return inputString;
    }

  }

  const handleDeleteNote = async (index) => {
    const updatedNotes = itemEditor.note.split("\n").filter((_, i) => i !== index);
    const res = await dispatch(editOrder({ user, field: "note", string: updatedNotes.join("\n"), id: itemEditor.id }))
    if (res.payload.status == 0) {
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search, type
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type
          }))

        });
      })
    }
    setOpen2(false)
  };
  const handleOrderItemCheckboxChange = (item) => (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const newSelectedItems = [...selectedOrderItems, item.id];
      setSelectedOrderItems(newSelectedItems);
      // Kiểm tra nếu tất cả items có price và chưa fulfil đã được chọn
      const itemsWithPriceAndNotFulfilled = data.data ? data.data.filter(item => item.price && !item.status_fulfil && !item.fulfil) : [];
      if (newSelectedItems.length === itemsWithPriceAndNotFulfilled.length) {
        setSelectAll(true);
      }
    } else {
      setSelectedOrderItems(prev => prev.filter(id => id !== item.id));
      setSelectAll(false);
    }
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      const allItemIds = data.data ? data.data.filter(item => item.price && !item.status_fulfil && !item.fulfil).map(item => item.id) : [];
      setSelectedOrderItems(allItemIds);
    } else {
      setSelectedOrderItems([]);
    }
  };

  const applyLuxuryProSelection = (orderItem, catalogId, manualPicks = {}) => {
    const catalog = luxurypro.find((c) => String(c.id) === String(catalogId));
    if (!catalog) return null;
    const result = resolveLuxuryPro(catalog, orderItem, manualPicks);
    const payload = {
      catalogId: catalog.id,
      catalogName: catalog.name,
      catalogThumbnail: catalog.thumbnail,
      catalogSku: result.catalogSku,
      variant_id: result.variant_id,
      picks: result.picks,
      matched: result.matched,
      orderSize: result.orderSize,
      orderColor: result.orderColor,
    };
    setLuxuryProSel((prev) => ({ ...prev, [orderItem.id]: payload }));
    setSelectedItems((prev) => {
      const base = prev[orderItem.id] || {
        items: data.data?.filter((row) => row.id === orderItem.id) || null,
        luxuryPro: true,
      };
      return {
        ...prev,
        [orderItem.id]: {
          ...base,
          sku: result.catalogSku,
          variant_id: result.variant_id,
          size: result.picks.size,
          color: result.picks.color,
          product: catalog.name,
        },
      };
    });
    console.log('[LuxuryPro fulfil]', {
      orderLineId: orderItem.id,
      order_id: orderItem.order_id,
      sizeRaw: orderItem.size,
      catalogName: catalog.name,
      SKU: result.catalogSku,
      variant_id: result.variant_id,
      picks: result.picks,
      autoMatched: result.matched,
      orderSize: result.orderSize,
      orderColor: result.orderColor,
      note: previewLuxuryProNote([orderItem]),
    });
    return result;
  };

  const handleLuxuryProCatalogChange = (orderItem, catalogId) => {
    if (!catalogId) {
      setLuxuryProSel((prev) => {
        const next = { ...prev };
        delete next[orderItem.id];
        return next;
      });
      return;
    }
    applyLuxuryProSelection(orderItem, catalogId, {});
  };

  const handleLuxuryProOptionChange = (orderItem, optionKey, value) => {
    const lp = luxuryProSel[orderItem.id];
    if (!lp?.catalogId) return;
    applyLuxuryProSelection(orderItem, lp.catalogId, { ...lp.picks, [optionKey]: value });
  };

  const applyMerchizeSelection = (orderItem, catalogId, manualPicks = {}) => {
    const catalog = merchize.find((c) => String(c.id) === String(catalogId));
    if (!catalog) return null;
    const result = resolveMerchize(catalog, orderItem, manualPicks);
    const payload = {
      catalogId: catalog.id,
      catalogName: catalog.name,
      catalogSku: catalog.sku,
      merchize_sku: result.merchize_sku,
      picks: result.picks,
      matched: result.matched,
    };
    setMerchizeSel((prev) => ({ ...prev, [orderItem.id]: payload }));
    setSelectedItems((prev) => {
      const base = prev[orderItem.id] || {
        items: data.data?.filter((row) => row.id === orderItem.id) || null,
        merchize: true,
      };
      return {
        ...prev,
        [orderItem.id]: {
          ...base,
          sku: result.merchize_sku,
          size: result.picks.size,
          color: result.picks.color,
          product: catalog.name,
        },
      };
    });
    return result;
  };

  const handleMerchizeCatalogChange = (orderItem, catalogId) => {
    if (!catalogId) {
      setMerchizeSel((prev) => {
        const next = { ...prev };
        delete next[orderItem.id];
        return next;
      });
      return;
    }
    applyMerchizeSelection(orderItem, catalogId, {});
  };

  const handleMerchizeOptionChange = (orderItem, optionKey, value) => {
    const current = merchizeSel[orderItem.id];
    if (!current?.catalogId) return;
    applyMerchizeSelection(orderItem, current.catalogId, { ...current.picks, [optionKey]: value });
  };

  const applyAnprintSelection = (orderItem, catalogId, manualPicks = {}) => {
    const catalog = anprint.find((c) => String(c.id) === String(catalogId));
    if (!catalog) return null;
    const result = resolveAnprint(catalog, orderItem, manualPicks);
    const payload = {
      catalogId: catalog.id,
      catalogName: catalog.name,
      catalogThumbnail: catalog.thumbnail,
      catalogSku: result.catalogSku,
      sku: result.sku,
      variant_id: result.variant_id,
      picks: result.picks,
      matched: result.matched,
      orderSize: result.orderSize,
      orderColor: result.orderColor,
    };
    setAnprintSel((prev) => ({ ...prev, [orderItem.id]: payload }));
    setSelectedItems((prev) => {
      const base = prev[orderItem.id] || {
        items: data.data?.filter((row) => row.id === orderItem.id) || null,
        anprint: true,
      };
      return {
        ...prev,
        [orderItem.id]: {
          ...base,
          sku: result.sku,
          variant_id: result.variant_id,
          size: result.picks.size,
          color: result.picks.color,
          product: catalog.name,
        },
      };
    });
    console.log('[Anprint fulfil]', {
      orderLineId: orderItem.id,
      order_id: orderItem.order_id,
      sizeRaw: orderItem.size,
      catalogName: catalog.name,
      sku: result.sku,
      picks: result.picks,
      autoMatched: result.matched,
      orderSize: result.orderSize,
      orderColor: result.orderColor,
    });
    return result;
  };

  const applyAnprintAutoOrSelect = (orderItem) => {
    const auto = autoResolveAnprint(anprint, orderItem);
    if (auto.matched && auto.catalog && auto.result) {
      const { catalog, result } = auto;
      const payload = {
        catalogId: catalog.id,
        catalogName: catalog.name,
        catalogThumbnail: catalog.thumbnail,
        catalogSku: result.catalogSku,
        sku: result.sku,
        variant_id: result.variant_id,
        picks: result.picks,
        matched: true,
        orderSize: result.orderSize,
        orderColor: result.orderColor,
      };
      setAnprintSel((prev) => ({ ...prev, [orderItem.id]: payload }));
      setSelectedItems((prev) => ({
        ...prev,
        [orderItem.id]: {
          items: data.data?.filter((row) => row.id === orderItem.id) || null,
          anprint: true,
          sku: result.sku,
          variant_id: result.variant_id,
          size: result.picks.size,
          color: result.picks.color,
          product: catalog.name,
        },
      }));
      console.log('[Anprint auto-map]', {
        orderLineId: orderItem.id,
        preferredId: auto.preferredId,
        catalog: catalog.name,
        sku: result.sku,
        picks: result.picks,
      });
      return true;
    }

    if (!auto.requireManual && (auto.preselectCatalog || auto.catalog)) {
      applyAnprintSelection(orderItem, (auto.preselectCatalog || auto.catalog).id, {});
      return false;
    }

    setAnprintSel((prev) => {
      const next = { ...prev };
      delete next[orderItem.id];
      return next;
    });
    setSelectedItems((prev) => ({
      ...prev,
      [orderItem.id]: {
        items: data.data?.filter((row) => row.id === orderItem.id) || null,
        anprint: true,
      },
    }));
    NotificationManager.warning(
      auto.reason || 'Anprint chưa auto-match được variant, vui lòng chọn catalog/SKU thủ công.',
      'Warning',
      2500
    );
    return false;
  };

  const handleAnprintCatalogChange = (orderItem, catalogId) => {
    if (!catalogId) {
      setAnprintSel((prev) => {
        const next = { ...prev };
        delete next[orderItem.id];
        return next;
      });
      return;
    }
    applyAnprintSelection(orderItem, catalogId, {});
  };

  const handleAnprintOptionChange = (orderItem, optionKey, value) => {
    const ap = anprintSel[orderItem.id];
    if (!ap?.catalogId) return;
    applyAnprintSelection(orderItem, ap.catalogId, { ...ap.picks, [optionKey]: value });
  };

  const handleAnprintVariantChange = (orderItem, variant) => {
    if (!variant?.catalogId) return;
    const catalog = anprint.find((c) => String(c.id) === String(variant.catalogId));
    if (!catalog) return;
    const result = resolveAnprintFromVariant(catalog, variant);
    const payload = {
      catalogId: catalog.id,
      catalogName: catalog.name,
      catalogThumbnail: catalog.thumbnail,
      catalogSku: result.catalogSku,
      sku: result.sku,
      variant_id: result.variant_id,
      picks: result.picks,
      matched: result.matched,
      orderSize: result.orderSize,
      orderColor: result.orderColor,
    };
    setAnprintSel((prev) => ({ ...prev, [orderItem.id]: payload }));
    setSelectedItems((prev) => {
      const base = prev[orderItem.id] || {
        items: data.data?.filter((row) => row.id === orderItem.id) || null,
        anprint: true,
      };
      return {
        ...prev,
        [orderItem.id]: {
          ...base,
          sku: result.sku,
          variant_id: result.variant_id,
          size: result.picks.size,
          color: result.picks.color,
          product: catalog.name,
        },
      };
    });
  };

  const sameFlashshipValue = (a, b) => String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();

  const normalizeFlashshipText = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ');
  const normalizeFlashshipColor = (value) => normalizeFlashshipText(value).replace(/\b(gd|bc|cc|ct)\b/g, ' ').replace(/\s+/g, ' ').trim();

  const findFlashshipOptionValue = (optionKey, wantedValue) =>
    [...new Set((flashshipVariants || []).map((variant) => variant[optionKey]).filter(Boolean))]
      .find((value) => sameFlashshipValue(value, wantedValue)) || '';

  const findFlashshipOptionAlias = (optionKey, wantedValues) => {
    for (const wantedValue of wantedValues) {
      const value = findFlashshipOptionValue(optionKey, wantedValue);
      if (value) return value;
    }
    return '';
  };

  const getFlashshipPreviousKeys = (optionKey) => {
    const index = flashshipOptionKeys.findIndex(({ key }) => key === optionKey);
    return index <= 0 ? [] : flashshipOptionKeys.slice(0, index).map(({ key }) => key);
  };

  const getFlashshipVariantsForOption = (picks = {}, optionKey) => {
    const filterKeys = getFlashshipPreviousKeys(optionKey);
    return (flashshipVariants || []).filter((variant) =>
      filterKeys.every((key) => !picks[key] || sameFlashshipValue(variant[key], picks[key]))
    );
  };

  const getFlashshipUniqueOption = (picks, optionKey) => {
    const values = [...new Set(getFlashshipVariantsForOption(picks, optionKey).map((variant) => variant[optionKey]).filter(Boolean))];
    return values.length === 1 ? values[0] : '';
  };

  const inferFlashshipPicksFromOrder = (orderItem) => {
    const raw = normalizeFlashshipText(`${orderItem?.size || ''} ${orderItem?.items_name || ''} ${orderItem?.sku || ''}`);
    const picks = {};
    const isTee = /\btee\b/.test(raw) || raw.includes('t shirt') || raw.includes('tshirt');

    if (isTee) {
      picks.product_type = findFlashshipOptionAlias('product_type', ['SHIRT', 'T-SHIRT']);
    } else if (raw.includes('hoodie')) {
      picks.product_type = findFlashshipOptionValue('product_type', 'HOODIE');
    } else if (raw.includes('sweatshirt')) {
      picks.product_type = findFlashshipOptionValue('product_type', 'SWEATSHIRT');
    } else if (raw.includes('tank')) {
      picks.product_type = findFlashshipOptionAlias('product_type', ['TANKTOP', 'TANK TOP']);
    } else if (raw.includes('tote')) {
      picks.product_type = findFlashshipOptionAlias('product_type', ['TOTEBAG', 'TOTE BAG']);
    }

    if (raw.includes('gildan')) {
      picks.brand = findFlashshipOptionValue('brand', 'GILDAN');
    } else if (raw.includes('comfort')) {
      picks.brand = findFlashshipOptionAlias('brand', ['COMFORT', 'COMFORT COLOR']);
      picks.product_type = picks.product_type || findFlashshipOptionAlias('product_type', ['SHIRT', 'T-SHIRT']);
    } else if (raw.includes('bella')) {
      picks.brand = findFlashshipOptionAlias('brand', ['BELLA', 'BELLA CANVAS']);
      picks.product_type = picks.product_type || findFlashshipOptionAlias('product_type', ['SHIRT', 'T-SHIRT']);
    } else if (raw.includes('colortone') || raw.includes('color tone')) {
      picks.brand = findFlashshipOptionValue('brand', 'COLORTONE');
      picks.product_type = picks.product_type || findFlashshipOptionAlias('product_type', ['SHIRT', 'T-SHIRT']);
    }

    if (isTee && raw.includes('youth')) {
      picks.product_type = picks.product_type || findFlashshipOptionAlias('product_type', ['SHIRT', 'T-SHIRT']);
      picks.brand = picks.brand || findFlashshipOptionValue('brand', 'GILDAN');
      const youthStyle = getFlashshipVariantsForOption(picks, 'style').find((variant) => sameFlashshipValue(variant.style, 'G5000B'))?.style;
      if (youthStyle) picks.style = youthStyle;
    } else if (isTee && /\b(woman|women|ladies|lady)\b/.test(raw)) {
      picks.product_type = picks.product_type || findFlashshipOptionAlias('product_type', ['SHIRT', 'T-SHIRT']);
      picks.brand = picks.brand || findFlashshipOptionValue('brand', 'GILDAN');
      const womenStyle = getFlashshipVariantsForOption(picks, 'style').find((variant) => sameFlashshipValue(variant.style, 'G5000L'))?.style;
      if (womenStyle) picks.style = womenStyle;
    }

    const style = getFlashshipUniqueOption(picks, 'style');
    if (style) picks.style = style;

    return picks;
  };

  const inferFlashshipColorFromOrder = (orderItem, picks = {}) => {
    const colorOptions = [...new Set(getFlashshipFilteredVariants(picks, 'color').map((variant) => variant.color).filter(Boolean))];
    const orderColor = String(orderItem?.color || '').trim();
    const exactColor = colorOptions.find((color) => sameFlashshipValue(color, orderColor));
    if (exactColor) return exactColor;

    const normalizedOrderColor = normalizeFlashshipColor(orderColor);
    const containedColor = colorOptions
      .sort((a, b) => String(a).length - String(b).length)
      .find((color) => {
        const normalizedColor = normalizeFlashshipColor(color);
        return normalizedOrderColor && (normalizedColor.includes(normalizedOrderColor) || normalizedOrderColor.includes(normalizedColor));
      });
    if (containedColor) return containedColor;

    const raw = normalizeFlashshipText(`${orderItem?.color || ''} ${orderItem?.size || ''} ${orderItem?.items_name || ''} ${orderItem?.sku || ''}`);
    return colorOptions
      .sort((a, b) => String(b).length - String(a).length)
      .find((color) => raw.includes(normalizeFlashshipText(color))) || '';
  };

  const getFlashshipOrderDefaults = (orderItem) => {
    const { orderSize, orderColor } = parseOrderSizeColor(orderItem);
    const defaults = inferFlashshipPicksFromOrder(orderItem);
    if (orderSize) {
      const sizes = [...new Set(getFlashshipFilteredVariants(defaults, 'size').filter((variant) => fieldMatches(variant.size, orderSize)).map((variant) => variant.size))];
      if (sizes.length === 1) defaults.size = sizes[0];
    }
    if (orderColor) {
      const colors = [...new Set(getFlashshipFilteredVariants(defaults, 'color').filter((variant) => fieldMatches(variant.color, orderColor)).map((variant) => variant.color))];
      if (colors.length === 1) defaults.color = colors[0];
    }
    if (!defaults.color) {
      const inferredColor = inferFlashshipColorFromOrder(orderItem, defaults);
      if (inferredColor) defaults.color = inferredColor;
    }
    defaults.printType = FLASHSHIP_DEFAULT_PRINT_TYPE;
    for (const { key } of flashshipOptionKeys) {
      if (defaults[key]) continue;
      if (key === 'brand') {
        const gildan = getFlashshipVariantsForOption(defaults, key).find((variant) => sameFlashshipValue(variant.brand, 'GILDAN'))?.brand;
        if (gildan) {
          defaults.brand = gildan;
          continue;
        }
      }
      const firstOption = [...new Set(getFlashshipVariantsForOption(defaults, key).map((variant) => variant[key]).filter(Boolean))]
        .sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }))?.[0];
      if (firstOption) defaults[key] = firstOption;
    }
    return defaults;
  };

  const getFlashshipFilteredVariants = (picks = {}, ignoreKey = '') =>
    (flashshipVariants || []).filter((variant) =>
      flashshipOptionKeys.every(({ key }) => key === ignoreKey || !picks[key] || sameFlashshipValue(variant[key], picks[key]))
    );

  const getFlashshipOptions = (orderItem, optionKey) => {
    const picks = flashshipPicks[orderItem.id] || getFlashshipOrderDefaults(orderItem);
    return [...new Set(getFlashshipVariantsForOption(picks, optionKey).map((variant) => variant[optionKey]).filter(Boolean))]
      .sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));
  };

  const resolveFlashshipVariant = (picks = {}) => {
    if (!flashshipOptionKeys.every(({ key }) => picks[key])) return null;
    return (flashshipVariants || []).find((variant) =>
      flashshipOptionKeys.every(({ key }) => sameFlashshipValue(variant[key], picks[key]))
    ) || null;
  };

  const applyFlashshipSelection = (orderItem, nextPicks) => {
    const variant = resolveFlashshipVariant(nextPicks);
    const variantId = variant?.variant_id ? String(variant.variant_id) : '';
    setFlashshipPicks((prev) => ({ ...prev, [orderItem.id]: nextPicks }));
    setFlashshipSel((prev) => ({ ...prev, [orderItem.id]: variantId }));
    setSelectedItems((prev) => {
      const current = prev[orderItem.id];
      if (!current) return prev;
      return {
        ...prev,
        [orderItem.id]: {
          ...current,
          variant_id: variantId,
          sku: variantId,
          size: nextPicks.size,
          color: nextPicks.color,
          printType: Number(nextPicks.printType || FLASHSHIP_DEFAULT_PRINT_TYPE),
          product: [nextPicks.product_type, nextPicks.brand, nextPicks.style].filter(Boolean).join(' - '),
        },
      };
    });
  };

  const fillFlashshipFirstOptions = (picks = {}) => {
    const next = { ...picks };
    for (const { key } of flashshipOptionKeys) {
      if (next[key]) continue;
      if (key === 'brand') {
        const gildan = getFlashshipVariantsForOption(next, key).find((variant) => sameFlashshipValue(variant.brand, 'GILDAN'))?.brand;
        if (gildan) {
          next.brand = gildan;
          continue;
        }
      }
      const firstOption = [...new Set(getFlashshipVariantsForOption(next, key).map((variant) => variant[key]).filter(Boolean))]
        .sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }))?.[0];
      if (firstOption) next[key] = firstOption;
    }
    return next;
  };

  const handleFlashshipOptionChange = (orderItem, optionKey, value) => {
    const current = flashshipPicks[orderItem.id] || getFlashshipOrderDefaults(orderItem);
    const changedIndex = flashshipOptionKeys.findIndex(({ key }) => key === optionKey);
    const next = {};
    flashshipOptionKeys.forEach(({ key }, index) => {
      if (index < changedIndex) next[key] = current[key];
      if (index === changedIndex) next[key] = value;
    });
    next.printType = current.printType || FLASHSHIP_DEFAULT_PRINT_TYPE;
    applyFlashshipSelection(orderItem, fillFlashshipFirstOptions(next));
  };

  const handleFlashshipPrintTypeChange = (orderItem, value) => {
    const current = flashshipPicks[orderItem.id] || getFlashshipOrderDefaults(orderItem);
    applyFlashshipSelection(orderItem, {
      ...current,
      printType: Number(value) || FLASHSHIP_DEFAULT_PRINT_TYPE,
    });
  };

  const isLegacyVariantFactory = (factory) => legacyVariantFactories.includes(factory);

  const getLegacyCatalog = (factory) => {
    if (factory == "Mango") return mango;
    if (factory == "Teecraft") return teecraft;
    if (factory == "Beeful") return beeful;
    if (factory == "PA-Beeful") return apbeeful;
    if (factory == "Printik") return printik;
    if (factory == "Merchfox") return merchfoxManual;
    return [];
  };

  const getLegacyProductLabel = (product) =>
    product?.name || product?.sku || product?.category || product?.id || "Unknown product";

  const getLegacyProductIndex = (factory, product) => {
    const catalog = getLegacyCatalog(factory);
    if (!product) return "";
    const index = catalog.findIndex((row) => row === product || (product.id && row.id === product.id));
    return index >= 0 ? String(index) : "";
  };

  const getLegacyProduct = (factory, productIndex) => {
    if (productIndex === undefined || productIndex === null || productIndex === "") return null;
    const index = Number(productIndex);
    if (!Number.isInteger(index) || index < 0) return null;
    return getLegacyCatalog(factory)?.[index] || null;
  };

  const getLegacyProductSizes = (factory, product) => {
    if (!product) return [];
    if (factory == "Merchfox") {
      return [...new Set((product.size || []).map((value) => Array.isArray(value) ? value[0] : value).filter(Boolean))];
    }
    return [...new Set((product.variations || []).map((variant) => variant.size).filter(Boolean))];
  };

  const getLegacyProductColors = (factory, product, selectedSize = "") => {
    if (!product) return [];
    if (factory == "Merchfox") return [...new Set((product.color || []).filter(Boolean))];
    return [...new Set((product.variations || [])
      .filter((variant) => !selectedSize || sameFlashshipValue(variant.size, selectedSize))
      .map((variant) => variant.color)
      .filter(Boolean))];
  };

  const resolveLegacyVariant = (factory, picks = {}) => {
    const product = getLegacyProduct(factory, picks.productIndex);
    if (!product || !picks.productIndex || !picks.size || !picks.color) return { product };
    if (factory == "Merchfox") {
      return {
        product,
        payload: {
          id: product.id,
          product: null,
          size: picks.size,
          color: picks.color,
          sku: undefined,
          cate: product.category,
        },
      };
    }
    const variant = (product.variations || []).find((row) =>
      sameFlashshipValue(row.size, picks.size) && sameFlashshipValue(row.color, picks.color)
    );
    return {
      product,
      variant,
      payload: variant ? {
        id: variant.id || product.id,
        product: getLegacyProductLabel(product),
        size: variant.size,
        color: variant.color,
        sku: variant.sku,
        cate: product.category,
      } : null,
    };
  };

  const applyLegacyVariantSelection = (orderItem, picks) => {
    const result = resolveLegacyVariant(ff, picks);
    setLegacyVariantPicks((prev) => ({ ...prev, [orderItem.id]: picks }));
    setSelectedItems((prev) => ({
      ...prev,
      [orderItem.id]: {
        ...(prev[orderItem.id] || {}),
        ...(result.payload || {}),
        legacyVariant: true,
        items: data.data && data.data.length ? data.data.filter((row) => row.id == orderItem.id) : null,
      },
    }));
  };

  const openLegacyVariantPicker = (orderItem, suggestedProduct = null, suggestedSize = "", suggestedColor = "") => {
    if (!orderHasDesignForLuxuryPro(orderItem)) {
      NotificationManager.error(`${ff}: cần ít nhất 1 design (front hoặc back)!`, "Error", 2000);
      return;
    }
    const productIndex = getLegacyProductIndex(ff, suggestedProduct);
    const product = getLegacyProduct(ff, productIndex);
    const sizes = getLegacyProductSizes(ff, product);
    const colors = getLegacyProductColors(ff, product, suggestedSize);
    const nextPicks = {
      productIndex,
      size: sizes.some((value) => sameFlashshipValue(value, suggestedSize)) ? suggestedSize : "",
      color: colors.some((value) => sameFlashshipValue(value, suggestedColor)) ? suggestedColor : "",
    };
    applyLegacyVariantSelection(orderItem, nextPicks);
    NotificationManager.warning(`${ff} chưa auto-match được variant, vui lòng chọn thủ công.`, "Warning", 2500);
  };

  const handleLegacyVariantChange = (orderItem, optionKey, value) => {
    const current = legacyVariantPicks[orderItem.id] || {};
    const next = { ...current, [optionKey]: value };
    if (optionKey == "productIndex") {
      next.size = "";
      next.color = "";
    }
    if (optionKey == "size") {
      next.color = "";
    }
    applyLegacyVariantSelection(orderItem, next);
  };

  const applyBurgerprintsSelection = (orderItem, detail, picks) => {
    const size = picks.size || '';
    const color = picks.color || '';
    const variant = findBurgerprintsVariant(detail?.variants || [], size, color);
    const payload = {
      shortCode: detail?.short_code || '',
      name: detail?.name || '',
      size,
      color,
      sku: variant?.sku || '',
      price: variant?.price || '',
    };
    setBurgerprintsSel((prev) => ({ ...prev, [orderItem.id]: payload }));
    setSelectedItems((prev) => ({
      ...prev,
      [orderItem.id]: {
        ...(prev[orderItem.id] || {}),
        items: data.data?.filter((row) => row.id === orderItem.id) || null,
        sku: variant?.sku || '',
        size,
        color,
        product: detail?.name || '',
        burgerprints: true,
      },
    }));
  };

  const loadBurgerprintsDetail = async (code) => {
    if (burgerprintsDetails[code]) return burgerprintsDetails[code];
    const res = await GET('/burgerprints-product', { code });
    const product = res?.data?.product;
    if (!product) throw new Error(res?.data?.message || 'Không tải được variant BurgerPrints');
    setBurgerprintsDetails((prev) => ({ ...prev, [code]: product }));
    return product;
  };

  const handleBurgerprintsCatalogChange = async (orderItem, shortCode) => {
    if (!shortCode) {
      setBurgerprintsSel((prev) => {
        const next = { ...prev };
        delete next[orderItem.id];
        return next;
      });
      setSelectedItems((prev) => ({
        ...prev,
        [orderItem.id]: {
          ...(prev[orderItem.id] || {}),
          sku: '',
          product: '',
          burgerprints: true,
        },
      }));
      return;
    }
    try {
      const detail = await loadBurgerprintsDetail(shortCode);
      const { orderSize, orderColor } = parseOrderSizeColor(orderItem);
      const size = matchBurgerprintsOption(orderSize, detail.sizes);
      const color = matchBurgerprintsOption(orderColor, colorsForSize(detail.variants, size));
      applyBurgerprintsSelection(orderItem, detail, { size, color });
    } catch (error) {
      NotificationManager.error(error.message || 'Không tải được variant BurgerPrints', 'Error', 2500);
    }
  };

  const applyBurgerprintsAutoOrSelect = async (orderItem) => {
    const detected = detectA2kProductCode(orderItem);
    const shortCode = suggestBurgerprintsShortCode(orderItem, detected.productCode);
    const keepSelected = () => {
      setSelectedItems((prev) => ({
        ...prev,
        [orderItem.id]: {
          items: data.data?.filter((row) => row.id === orderItem.id) || null,
          burgerprints: true,
        },
      }));
    };
    if (!shortCode) {
      keepSelected();
      NotificationManager.warning('BurgerPrints chưa auto-match được loại sản phẩm, vui lòng chọn catalog thủ công.', 'Warning', 2500);
      return;
    }
    try {
      const detail = await loadBurgerprintsDetail(shortCode);
      const matched = matchA2kVariant(detail, orderItem);
      applyBurgerprintsSelection(orderItem, detail, matched);
      if (!matched.matched) {
        NotificationManager.warning('BurgerPrints đã chọn catalog nhưng chưa khớp size/color, vui lòng chọn lại.', 'Warning', 2500);
      }
    } catch (error) {
      keepSelected();
      NotificationManager.error(error.message || 'Không tải được variant BurgerPrints', 'Error', 2500);
    }
  };

  const handleBurgerprintsOptionChange = (orderItem, optionKey, value) => {
    const current = burgerprintsSel[orderItem.id] || {};
    const detail = burgerprintsDetails[current.shortCode];
    if (!detail) return;
    const next = { size: current.size || '', color: current.color || '', [optionKey]: value };
    if (optionKey === 'size') {
      const colors = colorsForSize(detail.variants, next.size);
      if (!colors.includes(next.color)) next.color = matchBurgerprintsOption(current.color, colors);
    }
    applyBurgerprintsSelection(orderItem, detail, next);
  };

  const applyA2kSelection = (orderItem, detail, picks) => {
    const size = picks.size || '';
    const color = picks.color || '';
    const variant = findBurgerprintsVariant(detail?.variants || [], size, color);
    const payload = {
      productCode: detail?.product_code || '',
      name: detail?.name || '',
      size,
      color,
      sku: variant?.sku || '',
      price: variant?.price || '',
      printTech: detail?.print_tech || 'DTG Print',
    };
    setA2kSel((prev) => ({ ...prev, [orderItem.id]: payload }));
    setSelectedItems((prev) => ({
      ...prev,
      [orderItem.id]: {
        ...(prev[orderItem.id] || {}),
        items: data.data?.filter((row) => row.id === orderItem.id) || null,
        sku: variant?.sku || '',
        size,
        color,
        product: detail?.name || '',
        printTech: detail?.print_tech || 'DTG Print',
        a2k: true,
      },
    }));
  };

  const loadA2kDetail = async (code) => {
    if (a2kDetails[code]) return a2kDetails[code];
    const res = await GET('/a2k-product', { code });
    const product = res?.data?.product;
    if (!product) throw new Error(res?.data?.message || 'Không tải được variant A2K');
    setA2kDetails((prev) => ({ ...prev, [code]: product }));
    return product;
  };

  const handleA2kCatalogChange = async (orderItem, productCode) => {
    if (!productCode) {
      setA2kSel((prev) => {
        const next = { ...prev };
        delete next[orderItem.id];
        return next;
      });
      setSelectedItems((prev) => ({
        ...prev,
        [orderItem.id]: {
          ...(prev[orderItem.id] || {}),
          sku: '',
          product: '',
          a2k: true,
        },
      }));
      return;
    }
    try {
      const detail = await loadA2kDetail(productCode);
      const matched = matchA2kVariant(detail, orderItem);
      applyA2kSelection(orderItem, detail, matched);
    } catch (error) {
      NotificationManager.error(error.message || 'Không tải được variant A2K', 'Error', 2500);
    }
  };

  const handleA2kOptionChange = (orderItem, optionKey, value) => {
    const current = a2kSel[orderItem.id] || {};
    const detail = a2kDetails[current.productCode];
    if (!detail) return;
    const next = { size: current.size || '', color: current.color || '', [optionKey]: value };
    if (optionKey === 'size') {
      const colors = colorsForSize(detail.variants, next.size);
      if (!colors.includes(next.color)) next.color = matchA2kColor(current.color, colors) || (colors.length === 1 ? colors[0] : '');
    }
    applyA2kSelection(orderItem, detail, next);
  };

  const applyA2kAutoOrSelect = async (orderItem) => {
    const detected = detectA2kProductCode(orderItem);
    const keepSelected = () => {
      setSelectedItems((prev) => ({
        ...prev,
        [orderItem.id]: {
          items: data.data?.filter((row) => row.id === orderItem.id) || null,
          a2k: true,
        },
      }));
    };
    if (!detected.productCode) {
      keepSelected();
      NotificationManager.warning(detected.reason, 'Warning', 2500);
      return;
    }
    try {
      const detail = await loadA2kDetail(detected.productCode);
      const matched = matchA2kVariant(detail, orderItem);
      applyA2kSelection(orderItem, detail, matched);
      if (!matched.matched) {
        NotificationManager.warning('A2K đã chọn catalog nhưng chưa khớp size/color, vui lòng chọn lại.', 'Warning', 2500);
      }
    } catch (error) {
      keepSelected();
      NotificationManager.error(error.message || 'Không tải được variant A2K', 'Error', 2500);
    }
  };

  const handleCheckboxChange = (item) => (event) => {
    if (ff === 'Flashship') {
      const itemId = item.id;
      const isChecked = event.target.checked;
      if (!isChecked) {
        setSelectedItems((prev) => ({ ...prev, [itemId]: undefined }));
        setFlashshipSel((prev) => {
          const next = { ...prev };
          delete next[itemId];
          return next;
        });
        setFlashshipPicks((prev) => {
          const next = { ...prev };
          delete next[itemId];
          return next;
        });
        return;
      }
      if (!orderHasDesignForLuxuryPro(item)) {
        NotificationManager.error('Flashship: order miss design!', 'Error', 2000);
        return;
      }
      const picks = flashshipPicks[itemId] || getFlashshipOrderDefaults(item);
      const variant = resolveFlashshipVariant(picks);
      const variantId = variant?.variant_id ? String(variant.variant_id) : '';
      setFlashshipPicks((prev) => ({ ...prev, [itemId]: picks }));
      setFlashshipSel((prev) => ({ ...prev, [itemId]: variantId }));
      setSelectedItems((prev) => ({
        ...prev,
        [itemId]: {
          items: data.data?.filter((row) => row.id === itemId) || null,
          variant_id: variantId,
          sku: variantId,
          size: picks.size,
          color: picks.color,
          printType: Number(picks.printType || FLASHSHIP_DEFAULT_PRINT_TYPE),
          product: [picks.product_type, picks.brand, picks.style].filter(Boolean).join(' - '),
          flashship: true,
        },
      }));
      return;
    }

    if (ff === 'LuxuryPro') {
      const itemId = item.id;
      const isChecked = event.target.checked;
      const { orderSize, orderColor } = parseOrderSizeColor(item);
      console.log('[FF select] parsed', {
        ff,
        orderLineId: item.id,
        rawSize: item.size,
        orderSize,
        orderColor,
        note: previewLuxuryProNote([item]),
      });
      if (!isChecked) {
        setSelectedItems((prev) => ({ ...prev, [itemId]: undefined }));
        setLuxuryProSel((prev) => {
          const next = { ...prev };
          delete next[itemId];
          return next;
        });
        return;
      }
      if (!orderHasDesignForLuxuryPro(item)) {
        NotificationManager.error('LuxuryPro: cần ít nhất 1 design (front hoặc back)!', 'Error', 2000);
        return;
      }
      setSelectedItems((prev) => ({
        ...prev,
        [itemId]: {
          items: data.data?.filter((row) => row.id === itemId) || null,
          luxuryPro: true,
        },
      }));
      return;
    }

    if (ff === 'Merchize') {
      const itemId = item.id;
      const isChecked = event.target.checked;
      if (!isChecked) {
        setSelectedItems((prev) => ({ ...prev, [itemId]: undefined }));
        setMerchizeSel((prev) => {
          const next = { ...prev };
          delete next[itemId];
          return next;
        });
        return;
      }
      if (!orderHasDesignForLuxuryPro(item)) {
        NotificationManager.error('Merchize: cần ít nhất 1 design (front hoặc back)!', 'Error', 2000);
        return;
      }
      setSelectedItems((prev) => ({
        ...prev,
        [itemId]: {
          items: data.data?.filter((row) => row.id === itemId) || null,
          merchize: true,
        },
      }));
      return;
    }

    if (ff === 'Anprint') {
      const itemId = item.id;
      const isChecked = event.target.checked;
      if (!isChecked) {
        setSelectedItems((prev) => ({ ...prev, [itemId]: undefined }));
        setAnprintSel((prev) => {
          const next = { ...prev };
          delete next[itemId];
          return next;
        });
        return;
      }
      if (!orderHasDesignForLuxuryPro(item)) {
        NotificationManager.error('Anprint: cần ít nhất 1 design (front hoặc back)!', 'Error', 2000);
        return;
      }
      applyAnprintAutoOrSelect(item);
      return;
    }

    if (ff === 'BurgerPrints') {
      const itemId = item.id;
      const isChecked = event.target.checked;
      if (!isChecked) {
        setSelectedItems((prev) => ({ ...prev, [itemId]: undefined }));
        setBurgerprintsSel((prev) => {
          const next = { ...prev };
          delete next[itemId];
          return next;
        });
        return;
      }
      if (!orderHasDesignForLuxuryPro(item)) {
        NotificationManager.error('BurgerPrints: cần ít nhất 1 design (front hoặc back)!', 'Error', 2000);
        return;
      }
      applyBurgerprintsAutoOrSelect(item);
      return;
    }

    if (ff === 'A2K') {
      const itemId = item.id;
      const isChecked = event.target.checked;
      if (!isChecked) {
        setSelectedItems((prev) => ({ ...prev, [itemId]: undefined }));
        setA2kSel((prev) => {
          const next = { ...prev };
          delete next[itemId];
          return next;
        });
        return;
      }
      if (!orderHasDesignForLuxuryPro(item)) {
        NotificationManager.error('A2K: cần ít nhất 1 design (front hoặc back)!', 'Error', 2000);
        return;
      }
      applyA2kAutoOrSelect(item);
      return;
    }

    if (isLegacyVariantFactory(ff) && !event.target.checked) {
      const itemId = item.id;
      setSelectedItems((prev) => ({ ...prev, [itemId]: undefined }));
      setLegacyVariantPicks((prev) => {
        const next = { ...prev };
        delete next[itemId];
        return next;
      });
      return;
    }

    let size = item.size.replace("*", "").replace("Type: ", "")
      .replace("Fabric Brand: ", "")
      .replace("Style: ", "")
      .replace("Size: ", "")
      .replace(/'/g, "")
      .replace("Product Sides Options: ", "").replace(/ /g, "")
    const compoundStyles = ["WomensV-NeckT-Shirt", "WomenT-Shirt", "YouthT-Shirt", "UnisexT-Shirt", "V-NeckT-Shirt"]
      .sort((a, b) => b.length - a.length)
    const stylePlaceholders = {}
    let stylePhIdx = 0
    for (const st of compoundStyles) {
      const esc = st.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      size = size.replace(new RegExp(esc, "g"), () => {
        const token = `__ST${stylePhIdx}__`
        stylePlaceholders[token] = st
        stylePhIdx++
        return token
      })
    }
    size = size.replace(/T-Shirt/g, "TShirt")
    let sizeArray = size.split("-").map((part) => stylePlaceholders[part] || part)
    const bareTshirtToStyle = { Women: "WomenT-Shirt", Woman: "WomenT-Shirt", Unisex: "UnisexT-Shirt", Youth: "YouthT-Shirt" }
    if (sizeArray[2] === "TShirt" && bareTshirtToStyle[sizeArray?.[0]]) {
      sizeArray[2] = bareTshirtToStyle[sizeArray[0]]
    }
    const productSkuKey = `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`
    const ffSelectSize = item.size.includes("Size: US") ? sizeArray?.[2] : sizeArray?.[3]
    const ffSelectColor = item.color
    console.log("[FF select] parsed", { ff, orderLineId: item.id, rawSize: item.size, sizeArray, productSku: productSkuKey, size: ffSelectSize, color: ffSelectColor })

    let ffSKU = []
    let cate = ""
    let mainProduct = []
    if (ff == "Mango") {
      mainProduct = mango.filter(items => items.sku == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        console.log("[FF select] fail", {
          detail: mainProduct?.[0] ? "no matching variation for size/color" : "no catalog product for productSku",
          ff: "Mango",
          orderLineId: item.id,
          productSku: productSkuKey,
          catalogFound: !!mainProduct?.[0],
          size: ffSelectSize,
          color: ffSelectColor,
          sizeToken: sizeArray?.[3],
        })
        NotificationManager.error(`Mango does not have this data variable!`, "Error", 2000);
        openLegacyVariantPicker(item, mainProduct?.[0], ffSelectSize, ffSelectColor);
        return
      }
    } else if (ff == "Teecraft") {
      mainProduct = teecraft.filter(items => items.sku == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        console.log("[FF select] fail", { detail: mainProduct?.[0] ? "no matching variation" : "no catalog product", ff: "Teecraft", orderLineId: item.id, productSku: productSkuKey, catalogFound: !!mainProduct?.[0], size: ffSelectSize, color: ffSelectColor, sizeToken: sizeArray?.[3] })
        NotificationManager.error(`Teecraft does not have this data variable!`, "Error", 2000);
        openLegacyVariantPicker(item, mainProduct?.[0], ffSelectSize, ffSelectColor);
        return
      }
      cate = mainProduct?.[0].category
    }
    else if (ff == "Beeful") {
      mainProduct = beeful.filter(items => items.name == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        console.log("[FF select] fail", { detail: mainProduct?.[0] ? "no matching variation" : "no catalog product", ff: "Beeful", orderLineId: item.id, productSku: productSkuKey, catalogFound: !!mainProduct?.[0], size: ffSelectSize, color: ffSelectColor, sizeToken: sizeArray?.[3] })
        NotificationManager.error(`Beeful does not have this data variable!`, "Error", 2000);
        openLegacyVariantPicker(item, mainProduct?.[0], ffSelectSize, ffSelectColor);
        return
      }
    } else if (ff == "PA-Beeful") {
      mainProduct = apbeeful.filter(items => items.name == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        console.log("[FF select] fail", { detail: mainProduct?.[0] ? "no matching variation" : "no catalog product", ff: "PA-Beeful", orderLineId: item.id, productSku: productSkuKey, catalogFound: !!mainProduct?.[0], size: ffSelectSize, color: ffSelectColor, sizeToken: sizeArray?.[3] })
        NotificationManager.error(`Beeful does not have this data variable!`, "Error", 2000);
        openLegacyVariantPicker(item, mainProduct?.[0], ffSelectSize, ffSelectColor);
        return
      }
    } else if (ff == "Printik") {
      mainProduct = printik.filter(items => items.sku == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      ffSKU = mainProduct?.[0]?.variations.filter(items => {
        return items.size.toUpperCase().replace(/ /g, "") == sizeArray?.[3].toUpperCase().replace(/ /g, "") && items.color.toUpperCase().replace(/ /g, "") == item.color.toUpperCase().replace(/ /g, "")
      }) || []
      if (!ffSKU.length) {
        console.log("[FF select] fail", { detail: mainProduct?.[0] ? "no matching variation" : "no catalog product", ff: "Printik", orderLineId: item.id, productSku: productSkuKey, catalogFound: !!mainProduct?.[0], size: ffSelectSize, color: ffSelectColor, sizeToken: sizeArray?.[3] })
        NotificationManager.error(`Printik does not have this data variable!`, "Error", 2000);
        openLegacyVariantPicker(item, mainProduct?.[0], ffSelectSize, ffSelectColor);
        return
      }
    }
    else if (ff == "Merchfox") {
      mainProduct = item.size.includes("Size: US") ? merchfox.filter(items => items.sku == "Crocs") : merchfox.filter(items => items.sku == `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}`)
      if (mainProduct.length) {
        if (item.size.includes("Size: US") && !mainProduct[0].size.some(items => items[1] == sizeArray[2])) {
          console.log("[FF select] fail", { detail: "Crocs size not in catalog", ff: "Merchfox", orderLineId: item.id, productSku: "Crocs", size: ffSelectSize, color: ffSelectColor, sizeArray })
          NotificationManager.error("Crocs Merchfox does not have this size!", "Error", 2000);
        }
        if (!item.size.includes("Size: US") && !mainProduct[0].size.some(items => items == sizeArray?.[3])) {
          console.log("[FF select] fail", { detail: "size not in Merchfox list", ff: "Merchfox", orderLineId: item.id, productSku: productSkuKey, merchfoxCatalogSku: mainProduct[0]?.sku, size: ffSelectSize, color: ffSelectColor, sizeToken: sizeArray?.[3], allowedSizes: mainProduct[0]?.size })
          NotificationManager.error("Merchfox does not have this size!", "Error", 2000);
          return;
        }
        if (!mainProduct[0].color.some(items =>
          `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}` == "Unisex-BellaCanvas-UnisexT-Shirt" || `${sizeArray?.[0]}-${sizeArray?.[1]}-${sizeArray?.[2]}` == "Unisex-ComfortColor-UnisexT-Shirt" ?
            items.trim().toUpperCase() == item.color.trim().toUpperCase() :
            items.trim().toUpperCase() == item.color.trim().toUpperCase()
        ) && !item.size.includes("Size: US")) {
          console.log("[FF select] fail", { detail: "color not in Merchfox list", ff: "Merchfox", orderLineId: item.id, productSku: productSkuKey, merchfoxCatalogSku: mainProduct[0]?.sku, size: ffSelectSize, color: ffSelectColor })
          NotificationManager.error(`Merchfox does not have this color!`, "Error", 2000);
          return;
        }
      } else {
        console.log("[FF select] fail", { detail: "no catalog product for productSku", ff: "Merchfox", orderLineId: item.id, productSku: productSkuKey, size: ffSelectSize, color: ffSelectColor })
        NotificationManager.error(`Merchfox does not have this data variable!`, "Error", 2000);
        openLegacyVariantPicker(item, mainProduct?.[0], ffSelectSize, ffSelectColor);
        return
      }
    } else {
      return
    }

    if (orderHasDesignForFulfill(item) || orderHasDesignForLuxuryPro(item)) {
      const itemId = item.id;
      const isChecked = event.target.checked;
      let sizeCrocs = ""
      if (item.size.includes("Size: US")) {
        sizeCrocs = mainProduct[0].size.filter(items => items[1] == sizeArray[2])
      }
      if (item.size.includes("Size: US") && !sizeCrocs) {
        console.log("[FF select] fail", { detail: "Crocs sizeCrocs empty after filter", ff: "Merchfox", orderLineId: item.id, productSku: "Crocs", size: ffSelectSize, color: ffSelectColor, sizeArray })
        NotificationManager.error(`Merchfox does not have this size!`, "Error", 2000);
        return;
      }
      console.log("[FF select] ok", {
        ff,
        orderLineId: item.id,
        productSku: productSkuKey,
        size: ffSelectSize,
        color: ffSelectColor,
        variationSku: ffSKU?.[0]?.sku ?? null,
        merchfoxCatalogSku: ff === "Merchfox" ? mainProduct?.[0]?.sku : undefined,
        merchfoxCatalogId: ff === "Merchfox" ? mainProduct?.[0]?.id : undefined,
      })
      try {
        const matchedSize = item.size.includes("Size: US") ? sizeCrocs[0][0] : ffSKU?.[0]?.size || sizeArray?.[3];
        const matchedColor = item.size.includes("Size: US")
          ? "3D Printed"
          : ff == "Merchfox"
            ? mainProduct?.[0]?.color?.find((value) => sameFlashshipValue(value, item.color)) || item.color.trim()
            : ffSKU?.[0]?.color || item.color.trim();
        const matchedProductIndex = getLegacyProductIndex(ff, mainProduct?.[0]);
        setLegacyVariantPicks((prev) => ({
          ...prev,
          [itemId]: isChecked ? {
            productIndex: matchedProductIndex,
            size: matchedSize,
            color: matchedColor,
          } : undefined,
        }));
        setSelectedItems(prev => ({
          ...prev,
          [itemId]: isChecked ? {
            id: mainProduct?.[0]?.id || ffSKU?.[0]?.id, cate, product: getLegacyProductLabel(mainProduct?.[0]), size: matchedSize, color: matchedColor, sku: ffSKU?.[0]?.sku, items: data.data && data.data.length ? data.data.filter(items => items.id == itemId) : null
          } : undefined
        }));
      } catch (error) {
        console.log(error)
      }

    } else {
      console.log("[FF select] fail", { detail: "order miss design", ff, orderLineId: item.id, productSku: productSkuKey, size: ffSelectSize, color: ffSelectColor, rawSize: item.size, design_link: item.design_link })
      NotificationManager.error(`Order miss design!`, "Error", 2000);
    }
  };

  const handleOpenDialogFulfil = async (items) => {
    setSelectedItems([])
    setLuxuryProSel({})
    setAnprintSel({})
    setFlashshipSel({})
    setFlashshipPicks({})
    setLegacyVariantPicks({})
    setBurgerprintsSel({})
    setA2kSel({})
    setItemEditor(items)
    setOpen5(true)
  };

  const handleCheckBoxFF = async (items) => {
    if (items.fulfil_id) {
      setItemEditor(items)
      setOpen8(true)
    }
  };

  const handleCopyClick = (items) => {
    let data_copy = [items.customer_name, items.address[0], items.address[1], items.address[2], items.address[3], items.address[4], items.address[5], "", items.images]
    NotificationManager.success(`Copied information!`, "Error", 700);
    navigator.clipboard.writeText(data_copy.join("\t"))
      .catch(err => console.error('Failed to copy text: ', err));
  };

  const handleFulFil = async () => {
    let res
    let i = 0
    let newData = []
    Object.keys(selectedItems).forEach(itemId => {
      const item = selectedItems[itemId];
      newData.push({
        items: selectedItems[itemId].items,
        sku: selectedItems[itemId].sku,
        variant_id: selectedItems[itemId]?.variant_id,
        color: selectedItems[itemId]?.color,
        size: selectedItems[itemId]?.size,
        printType: selectedItems[itemId]?.printType,
        id: selectedItems[itemId]?.id,
        cate: selectedItems[itemId]?.cate,
        catalogName: luxuryProSel[itemId]?.catalogName || anprintSel[itemId]?.catalogName,
        picks: luxuryProSel[itemId]?.picks || anprintSel[itemId]?.picks,
        printTech: selectedItems[itemId]?.printTech,
      })
      if (ff != "Merchfox" && item != undefined && (!item?.product || !item?.size || !item?.sku)) {
        if (ff == "Mango" && item != undefined && item?.sku) {
        } else if (ff == "Printik" && item != undefined && item?.sku) {
        } else if (ff == "Teecraft" && item != undefined && item?.sku) {
        } else if (ff == "Beeful" && item != undefined && item?.id) { } else if (ff == "PA-Beeful" && item != undefined && item?.id) { }
        else if (ff == "LuxuryPro" && item != undefined && item?.sku && item?.variant_id) { }
        else if (ff == "Anprint" && item != undefined && item?.sku) { }
        else if (ff == "Merchize" && item != undefined && item?.sku) { }
        else if (ff == "Flashship" && item != undefined && item?.variant_id) { }
        else if (ff == "BurgerPrints" && item != undefined && item?.sku) { }
        else if (ff == "A2K" && item != undefined && item?.sku) { }
        else {
          NotificationManager.error(`One item incomplete.`, "Error", 2000);
          newData = []
          i++
          return
        }
      } else if (ff == "Merchfox" && item != undefined) {
        console.log(item)
        if ((!item?.id || !item?.size || !item?.color) && !item.items[0].size.includes("Size: US")) {
          NotificationManager.error(`One item incomplete.`, "Error", 2000);
          newData = []
          i++
          return
        }
      }
    });
    if (ff == "Mango") {
      if (i == 0) {
        res = await dispatch(ffmango({ data: newData, user }))
      }
    }
    else if (ff == "Printik") {
      if (i == 0) {
        res = await dispatch(ffprintik({ data: newData, user }))
      }
    }
    else if (ff == "Teecraft") {
      if (i == 0) {
        res = await dispatch(ffteecraft({ data: newData, user }))
      }
    }
    else if (ff == "Merchfox") {
      if (i == 0) {
        res = await dispatch(ffmerchfox({ data: newData, user }))
      }
    }
    else if (ff == "Beeful") {
      if (i == 0) {
        res = await dispatch(ffbeeful({ data: newData, user }))
      }
    }
    else if (ff == "PA-Beeful") {
      if (i == 0) {
        res = await dispatch(ffpabeeful({ data: newData, user }))
      }
    }
    else if (ff == "Printway") {
      if (i == 0) {
        res = await dispatch(ffprintway({ data: newData, user }))
      }
    }
    else if (ff == "LuxuryPro") {
      if (i == 0) {
        console.log('[LuxuryPro fulfil] size truyền vào', newData.map((row) => {
          const item = row.items?.[0] || {};
          return {
            orderLineId: item.id,
            order_id: item.order_id,
            sizeRaw: item.size,
            sizeMatched: row.picks?.size ?? row.size,
            picks: row.picks,
            note: previewLuxuryProNote([item]),
          };
        }));
        res = await dispatch(ffluxurypro({ data: newData, user }));
      }
    }
    else if (ff == "Anprint") {
      if (i == 0) {
        console.log('[Anprint fulfil]', newData.map((row) => ({
          sku: row.sku,
          size: row.size,
          color: row.color,
          picks: row.picks,
        })));
        res = await dispatch(ffanprint({ data: newData, user }));
      }
    }
    else if (ff == "Merchize") {
      if (i == 0) {
        res = await dispatch(ffmerchize({ data: newData, user }));
      }
    }
    else if (ff == "Flashship") {
      if (i == 0) {
        res = await dispatch(ffflashship({ data: newData, user }));
      }
    }
    else if (ff == "BurgerPrints") {
      if (i == 0) {
        res = await dispatch(ffburgerprints({ data: newData, user }));
      }
    }
    else if (ff == "A2K") {
      if (i == 0) {
        res = await dispatch(ffa2k({ data: newData, user }));
      }
    }
    if (res?.payload?.status == 0) {
      setOpen5(false)
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search, type
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type
          }))

        });
      })
    } else if (res?.payload?.message) {
      NotificationManager.error(res.payload.message, 'Error', 4000);
    }
  }

  const handleChangePage = async (newPage) => {
    await dispatch(updateCurrentPage(newPage))
  };

  const handleAddBasecost = async (item) => {
    setItemEditor(item)
    item.basecost != 0 ? setBasecost(item.basecost) : setBasecost("")
    setOpen3(true)
  }
  const handleChangeTracking = async (e) => {
    const res = await dispatch(editOrder({ user, field: "tracking", liststring: [e ? e : tracking, fulfil, lineship], order_id: itemEditor.order_id, store: itemEditor.store_name, id: itemEditor.id, user }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
    setOpen1(false)
  }

  const handleChangeNote = async (e) => {
    const res = await dispatch(editOrder({ user, field: "note", string: !itemEditor.note ? `${user.replace("@gmail.com", "")}: ${note}` : `${itemEditor.note}\n${user.replace("@gmail.com", "")}:${note}`, id: itemEditor.id }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
    setOpen2(false)
  }

  const handleChangeVariant2 = async () => {
    if ((size || "") !== (itemEditor.size || "")) {
      await dispatch(editOrder({ user, field: "size", string: size, id: itemEditor.id }))
    }
    if ((color || "") !== (itemEditor.color || "")) {
      await dispatch(editOrder({ user, field: "color", string: color, id: itemEditor.id }))
    }
    setOpen6(false)
  }

  const handleClear = async (e) => {
    const res = await dispatch(editOrder({ user, field: "fulfil", id: itemEditor.fulfil_id }))
    if (res.payload.status == 0) {
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search, type
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type
          }))

        });
      })
    }
    setOpen8(false)
  }

  const handleChangeBasecost = async (e) => {
    const res = await dispatch(editOrder({ user, field: "basecost", string: basecost, id: itemEditor.id }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
    setOpen3(false)
  }

  const handleShowInformation = (item) => {
    setItemEditor(item)
    setOpen4(true)
  }

  const handleAddTracking = (item) => {
    setTracking(item.tracking)
    setLineship(item.lineship)
    setFulfil(item.fulfil)
    setItemEditor(item)
    setOpen1(true)
  };

  const handleAddNote = (item) => {
    setNote("")
    setItemEditor(item)
    setOpen2(true)
  };

  const handleClose1 = () => {
    setOpen1(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleClose3 = () => {
    setOpen3(false);
  };

  const handleClose4 = () => {
    setOpen4(false);
  };

  const handleClose5 = () => {
    setOpen5(false);
  };
  const handleClose6 = () => {
    setOpen6(false);
  };
  const handleClose8 = () => {
    setOpen8(false);
  };

  const handleOpenBulkDialog = () => {
    setOpenBulkDialog(true);
    setBulkFF("");
    setBulkStatusFulfil(false);
  };

  const handleCloseBulkDialog = () => {
    setOpenBulkDialog(false);
    setBulkFF("");
    setBulkStatusFulfil(false);
  };

  const handleBulkProcess = async () => {
    const selectedItems = data.data?.filter(item => selectedOrderItems.includes(item.id) && item.price && !item.status_fulfil && !item.fulfil) || [];

    if (selectedItems.length === 0) {
      NotificationManager.error("No items selected for processing!", "Error", 2000);
      return;
    }

    if (!bulkFF.trim()) {
      NotificationManager.error("Please enter FF value!", "Error", 2000);
      return;
    }

    try {
      // Lấy danh sách IDs của các items được chọn
      const selectedIds = selectedItems.map(item => item.id);

      // Gửi bulk request với các thông tin cần thiết
      const bulkData = {
        ids: selectedIds,
        bulkFF: bulkFF.trim(),
        status_fulfil: bulkStatusFulfil,
        user: user
      };

      console.log('Bulk process data:', bulkData);

      // Gọi API bulk update
      const res = await dispatch(bulkUpdateOrders(bulkData));

      if (res.payload?.status === 0) {
        // Refresh data sau khi thành công
        bcrypt.genSalt(10, (err, salt) => {
          bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
            await dispatch(getOrders({
              store: filterStore, order_status,
              startDate: moment(startDate).startOf("day").format("x"),
              endDate: moment(endDate).endOf("day").format("x"),
              currentPage,
              search,
              version: hash,
              type
            }));
          });
        });

        // Clear selection
        setSelectedOrderItems([]);
        setSelectAll(false);
        setOpenBulkDialog(false);
      }

    } catch (error) {
      console.error('Bulk process error:', error);
      NotificationManager.error("Error processing items!", "Error", 2000);
    }
  };



  const changeCheckBox = async (items, checked, field, id) => {
    setItemEditor(items)
    const res = await dispatch(editOrder({ user, field, boolean: checked, id }))
    if (res.payload.status == 0) {
      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //       type
      //     }))

      //   });
      // })
    }
  }

  const handleChangeVariant = (items) => {
    setItemEditor(items)
    setSize(items.size || "")
    setColor(items.color || "")
    setOpen6(true)
  }

  const handleChangeColor = (items) => handleChangeVariant(items)
  const handleChangeSize = (items) => handleChangeVariant(items)

  const handleChangeShipping = async (items) => {
    setItemEditor(items)
    setShippingMethod(items.shipping_method || "")
    setOpenShippingDialog(true)
  }

  const handleUpdateShipping = async () => {
    const res = await dispatch(editOrder({ user, field: "shipping_method", string: shippingMethod, id: itemEditor.id }))
    setOpenShippingDialog(false)
  }

  const handleCloseShippingDialog = () => {
    setOpenShippingDialog(false)
  }

  const capitalizeAndColorBeforeColon = (note) => {
    const lines = note.split('\n');
    const totalLines = lines.length;
    const linesToShow = 3;

    const displayLines = totalLines > linesToShow
      ? ['...'].concat(lines.slice(totalLines - linesToShow))
      : lines;

    return displayLines.map((line, index) => {
      const [beforeColon, afterColon] = line.split(':', 2);
      const capitalizedBeforeColon = beforeColon.trim().charAt(0).toUpperCase() + beforeColon.trim().slice(1);
      return (
        <div key={index} style={{ marginBottom: index < displayLines.length - 1 ? '4px' : '0' }}>
          <span style={{
            color: '#d32f2f',
            fontWeight: 600,
            fontSize: '11px'
          }}>{capitalizedBeforeColon}</span>
          <span style={{ color: '#666', marginLeft: '3px' }}>: {afterColon ? afterColon.trim() : ""}</span>
        </div>
      );
    });
  };
  function getFirstWords(text) {
    if (text.length > 35) {
      return text.substring(0, 35) + "...";
    } else {
      return text;
    }
  }




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ paddingTop: '24px', paddingBottom: '24px' }}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card sx={{
              borderRadius: '16px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              overflow: 'hidden',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
            }}>
              <div style={{ padding: '24px' }}>
                {selectedOrderItems.length > 0 && (
                  <div style={{
                    marginBottom: '20px',
                    padding: '16px 20px',
                    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                    borderRadius: '12px',
                    border: '1px solid #90caf9',
                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.1)'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Icon sx={{ color: '#1976d2', fontSize: '24px' }}>check_circle</Icon>
                        <span style={{ fontWeight: 'bold', color: '#1565c0', fontSize: '15px' }}>
                          {selectedOrderItems.length} item(s) selected
                        </span>
                      </div>
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <button
                          onClick={handleOpenBulkDialog}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 20px',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            borderRadius: '10px',
                            border: 'none',
                            background: 'linear-gradient(135deg, #00bcd4 0%, #0097a7 100%)',
                            color: '#fff',
                            cursor: 'pointer',
                            textTransform: 'none',
                            boxShadow: '0 2px 8px rgba(0, 188, 212, 0.3)',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 188, 212, 0.4)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 188, 212, 0.3)';
                          }}
                        >
                          <Icon>play_arrow</Icon>
                          Process Selected
                        </button>
                        <button
                          onClick={() => {
                            setSelectedOrderItems([]);
                            setSelectAll(false);
                          }}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 20px',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            borderRadius: '10px',
                            border: '2px solid #ff9800',
                            background: 'transparent',
                            color: '#ff9800',
                            cursor: 'pointer',
                            textTransform: 'none',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#ff9800';
                            e.currentTarget.style.color = '#fff';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 152, 0, 0.3)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.color = '#ff9800';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                          }}
                        >
                          <Icon>clear</Icon>
                          Clear Selection
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <HTMLDataTable
                  table={{
                    columns: [
                      {
                        Header: (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <label className="table-check" title="Select all">
                              <input
                                type="checkbox"
                                checked={selectAll}
                                disabled={readOnly}
                                onChange={readOnly ? undefined : handleSelectAllChange}
                                aria-label="Select all"
                                ref={(input) => {
                                  if (input) {
                                    input.indeterminate = selectedOrderItems.length > 0 && selectedOrderItems.length < (data.data?.filter(item => item.price && !item.status_fulfil && !item.fulfil).length || 0);
                                  }
                                }}
                              />
                              <span className="table-check-box" />
                            </label>
                          </div>
                        ),
                        accessor: "select",
                        align: "center",
                        width: "52px"
                      },
                      { Header: "Date", accessor: "date", align: "center" },
                      { Header: "Order Id", accessor: "order_id", align: "left" },
                      { Header: "Name", accessor: "items_name", align: "left" },
                      { Header: "Quantity", accessor: "quantity", align: "left" },
                      { Header: "Basecost / Price", accessor: "price", align: "left" },
                      { Header: "Track / Fulfil", accessor: "tracking", align: "left" },
                      { Header: "Note", accessor: "note", align: "left" },
                      { Header: "Design", accessor: "design", align: "left" },
                      { Header: "Status Fulfil", accessor: "status_fulfil", align: "center" },
                      { Header: "Shipping", accessor: "shipping", align: "center" },
                      { Header: "Fulfil", accessor: "fulfil", align: "center" },
                    ],
                    rows: data.data && data.data.length > 0 ? [...data.data.map((items, index) => ({
                      order_status: items.error_order,
                      id: items.order_id,
                      cancel: items.tracking,
                      itemEditor: itemEditor.order_id,
                      select: !readOnly && items.price && !items.status_fulfil && !items.fulfil ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <label className="table-check" title="Select row">
                            <input
                              type="checkbox"
                              checked={selectedOrderItems.includes(items.id)}
                              onChange={handleOrderItemCheckboxChange(items)}
                              aria-label="Select row"
                            />
                            <span className="table-check-box" />
                          </label>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '40px' }}>
                          <span style={{
                            fontSize: '10px',
                            color: '#9e9e9e',
                            fontStyle: 'italic'
                          }}>
                            N/A
                          </span>
                        </div>
                      ),
                      date: <>
                        {items.price || search || order_status == "tracking" ? (
                          <span className={items?.price > 0 ? "tc-text" : "tc-muted"} style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}>
                            {moment(items.date).format("HH:mm DD/MM")}
                          </span>
                        ) : ""}
                      </>,
                      order_id: <>
                        {
                          items.price || search || order_status == "tracking" ? (
                            <div className="tc-stack">
                              <p className={items.price ? "tc-text" : "tc-muted"}>{items.order_id}</p>
                              <div className="tc-row">
                                {items?.store_name == "Sesverin" || items?.store_name == "Navlak" || items?.store_name == "Ladyjacket" || items?.store_name == "Atorcus" || items?.store_name == "Prashirt" || items?.store_name == "Thalath" ?
                                  <img
                                    src="https://egead.nyc3.digitaloceanspaces.com/1728270648803h7puf0.jpg"
                                    alt=""
                                    style={{ height: 16, borderRadius: 3 }}
                                  />
                                  : null
                                }
                                <p className="tc-muted">{items.store_name}</p>
                              </div>
                            </div>
                          ) : ""}
                      </>,

                      items_name: <div className="tc-row" style={{ alignItems: "flex-start", gap: 10 }}>
                        {items.images && (
                          <a href={modifyUrlString(items.images)} target="_blank" rel="noopener noreferrer">
                            <img
                              className="tc-thumb"
                              src={modifyUrlString(items.images)}
                              alt={items.items_name}
                            />
                          </a>
                        )}
                        <div className="tc-stack" style={{ flex: 1 }}>
                          <div>
                            <a
                              href={items.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="tc-link"
                            >
                              {getFirstWords(items.items_name)}
                            </a>
                            <span className="tc-sku" style={{ marginLeft: 6 }}>{items.sku}</span>
                          </div>
                          <div
                            className="tc-size"
                            onClick={(event) => {
                              if (event.target.closest("a, img")) return;
                              if (!readOnly && !items.status_fulfil) handleChangeSize(items);
                            }}
                            style={{ cursor: readOnly || items.status_fulfil ? "default" : "pointer" }}
                          >
                            <SizeHtml value={items.size} />
                          </div>
                          <div className="tc-row" style={{ flexWrap: "wrap" }}>
                            <span
                              className="tc-chip tc-chip--danger"
                              onClick={!readOnly && !items.status_fulfil ? () => handleChangeColor(items) : null}
                              style={{ cursor: readOnly || items.status_fulfil ? "default" : "pointer" }}
                            >
                              {!items.color || items.color == "" ? "None" : items.color}
                            </span>
                            <button
                              type="button"
                              className="tc-icon-btn"
                              onClick={() => handleShowInformation(items)}
                              title="Order info"
                            >
                              <InfoOutlinedIcon />
                            </button>
                            <button
                              type="button"
                              className="tc-icon-btn"
                              onClick={() => handleCopyClick(items)}
                              title="Copy"
                            >
                              <ContentCopyIcon />
                            </button>
                            <OrderHistoryButton onClick={() => setHistoryItem(items)} />
                          </div>
                        </div>
                      </div>,
                      quantity: (
                        <div className="tc-row">
                          <span className="tc-text">{items.quantity}</span>
                          {items.quantity > 1 ? (
                            <ArrowDropUpIcon style={{ color: "#10b981", fontSize: 16 }} />
                          ) : null}
                        </div>
                      ),
                      price: items.price || items.basecost || items.status_fulfil ? (
                        <div className="tc-stack">
                          {(items.price || items.basecost || items.status_fulfil) && (
                            <div
                              className={`tc-row ${(!items.basecost || items.basecost == 0) ? "tc-warn-box" : ""}`}
                              onClick={can("basecost") && (!items.basecost || items.basecost == 0) ? () => handleAddBasecost(items) : null}
                              style={{ cursor: can("basecost") && (!items.basecost || items.basecost == 0) ? "pointer" : "default" }}
                            >
                              <span className="tc-label">Cost</span>
                              {items.status_fulfil && items.basecost == 0 ?
                                <span
                                  className="tc-muted"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (can("basecost")) handleAddBasecost(items);
                                  }}
                                >+</span>
                                : items?.basecost ? (
                                  <span
                                    className="tc-money tc-money--link"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (can("basecost")) handleAddBasecost(items);
                                    }}
                                  >${items.basecost.toFixed(2).toString()}</span>
                                ) : (
                                  <span className="tc-empty">Add</span>
                                )}
                            </div>
                          )}
                          {items.price ? (
                            <div className="tc-row">
                              <span className="tc-label">Price</span>
                              <span className="tc-money tc-money--ok">${items.price}</span>
                            </div>
                          ) : null}
                        </div>
                      ) : null,
                      tracking: (
                        <TrackingCell
                          tracking={items.tracking}
                          fulfil={items.fulfil}
                          deli={items.deli}
                          isDeli={items.is_deli}
                          status={items.status}
                          cong={items.cong}
                          showFulfil
                          onClick={
                            (items.tracking && (moment().unix() * 1000 - items.updatedAt > 86400000)) || !can("tracking")
                              ? undefined
                              : () => handleAddTracking(items)
                          }
                        />
                      ),
                      note: (
                        <NoteCell
                          customerNote={items.price ? items.customer_note : ""}
                          note={items.note}
                          canEdit={can("note")}
                          onAdd={() => handleAddNote(items)}
                        />
                      ),
                      design: (
                        <div className="tc-stack">
                          {items?.design_link ? (
                            <>
                              {items?.design_link?.front ? items?.design_link?.front == "upload" ?
                                <span className="tc-chip tc-chip--warn">Uploading</span>
                                : <a
                                  className="tc-design"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={items?.design_link.front}
                                  title="Front Design"
                                >
                                  Front
                                </a> : null}
                              {items?.design_link?.back ? (
                                <a
                                  className="tc-design"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={items?.design_link.back}
                                  title="Back Design"
                                >
                                  Back
                                </a>
                              ) : null}
                            </>
                          ) : null}
                        </div>
                      ),
                      status_fulfil: (
                        <div className="tc-stack">
                          <label className="table-check">
                            <input
                              type="checkbox"
                              checked={items?.status_fulfil || false}
                              disabled={readOnly}
                              onChange={() => can("status_fulfil") && !items?.tracking.includes("cancel") && !items?.tracking.includes("refund") && !items.fulfil.includes("A-") ? changeCheckBox(items, items?.status_fulfil, "status_fulfil", items.id) : items.fulfil.includes("A-") && can("status_fulfil") ? handleCheckBoxFF(items) : null}
                            />
                            <span className="table-check-box" />
                          </label>
                          {items.fulfil.includes("A-") ? <span className="tc-muted">{items.fulfil_id}</span> : null}
                        </div>
                      ),
                      shipping: (
                        <div style={{ cursor: readOnly ? "default" : "pointer" }} onClick={readOnly ? undefined : () => handleChangeShipping(items)}>
                          <span className="tc-chip">{items.shipping_method || "—"}</span>
                        </div>
                      ),
                      fulfil: (
                        <>
                          {items.price && can("status_fulfil") ? (
                            <button
                              type="button"
                              className="tc-action"
                              onClick={() => handleOpenDialogFulfil(items)}
                              title="Fulfil"
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#fff" />
                              </svg>
                            </button>
                          ) : null}
                        </>
                      ), index: true
                    })
                    )] : []
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '20px 0 0 0',
                  marginTop: '20px',
                  borderTop: '1px solid #e9ecef',
                  width: '100%',
                  minWidth: 0
                }}>
                  <MDPageBar
                    totalPage={data.totalPage}
                    currentPage={currentPage}
                    onChange={handleChangePage}
                  />
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
      <OrderHistoryDialog
        open={Boolean(historyItem)}
        item={historyItem}
        user={user}
        onClose={() => setHistoryItem(null)}
      />
      <Dialog open={open1} onClose={handleClose1}>
        <DialogTitle>Tracking - Fulfil</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <TextField
              label="Tracking"
              sx={{ margin: "10px" }}
              value={tracking}
              onChange={(e) => setTracking(e.target.value)}
            />
            <TextField
              label="Lineship"
              sx={{ margin: "10px" }}
              value={lineship}
              onChange={(e) => setLineship(e.target.value)}
            />
            <TextField
              label="Fulfil"
              sx={{ margin: "10px" }}
              value={fulfil}
              onChange={(e) => setFulfil(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleChangeTracking("cancel")} variant="outline" style={{ color: "red" }}>
            Cancelled
          </Button>
          <Button onClick={() => handleChangeTracking("refund")} variant="outline" style={{ color: "orange" }}>
            Refunded
          </Button>
          <Button onClick={() => handleChangeTracking()} variant="outline" style={{ color: "green" }}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <NoteDialog open2={open2} handleDeleteNote={handleDeleteNote} handleClose2={handleClose2} note2={note} note={itemEditor.note} user={user.replace("@gmail.com", "")} setNote={setNote} handleChangeNote={handleChangeNote} />
      <Dialog open={open3} onClose={handleClose3}>
        <DialogTitle>Basecost</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <TextField
              label="Basecost"
              sx={{ margin: "10px", width: 300 }}
              value={basecost}
              onChange={(e) => setBasecost(e.target.value)}
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleChangeBasecost()} variant="outline" style={{ color: "green" }}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={open4} onClose={handleClose4}>
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <GreenSection>
              <CaptionText>Order ID: <InfoText>{itemEditor.order_id}</InfoText></CaptionText>
              <CaptionText>Store: <InfoText>{itemEditor.store_name}</InfoText></CaptionText>
              <CaptionText>Payment Method: <div style={{ display: "flex", flexDirection: "row", marginLeft: 5 }}><img src={itemEditor.shield ? itemEditor.shield.includes("PayPal:") ? "https://egead.nyc3.digitaloceanspaces.com/pp.png" : itemEditor.shield.includes("Stripe:") ? "https://egead.nyc3.digitaloceanspaces.com/stripe.png" : "https://egead.nyc3.digitaloceanspaces.com/card.png" : "https://egead.nyc3.digitaloceanspaces.com/card.png"} style={{ height: 20, marginRight: 5 }}></img>{itemEditor.shield ? itemEditor.shield.replace("PayPal:", "").replace("Stripe:", "").replace("Stripe", "") : itemEditor.shield}</div></CaptionText>
            </GreenSection>
            <hr style={{ marginTop: 10, marginBottom: 10 }} />
            {data.data && data.data.length ? data.data.filter(item => item.order_id === itemEditor.order_id && item.store_name === itemEditor.store_name).map((items, index) => (
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", position: "relative" }} key={index} >
                <BlueSection >
                  <img src={items.images} style={{ width: "60px", objectFit: "contain", marginRight: "10px" }}></img>
                  <div>
                    <CaptionText>
                      <a href={items.link} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5, marginRight: "5px", fontWeight: '400' }}>{items.items_name}</a>
                    </CaptionText>
                    <CaptionText>
                      <NormalText><SizeHtml value={items.size} /> - <RedText>{items.color}</RedText></NormalText>
                    </CaptionText>
                  </div>
                </BlueSection>
                <span style={{ position: "absolute", top: -7, right: -9, background: "white", borderRadius: "100%", width: "25px", height: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <strong style={{ color: "black" }}>{items.quantity}</strong>
                </span>
              </div>
            )) : null}
            <hr style={{ marginTop: 10, marginBottom: 10 }} />
            <DarkSection>
              <CaptionText2>
                Ship to: <NormalText><HighlightedText>{itemEditor.customer_name}</HighlightedText> - {itemEditor?.address ? `${itemEditor?.address[0]} ${itemEditor?.address[1]}, ${itemEditor?.address[2]}, ${itemEditor?.address[3]} ${itemEditor?.address[4]}, United States` : null}</NormalText>
              </CaptionText2>
              <CaptionText2>
                Email: <NormalText>{itemEditor.email}</NormalText>
              </CaptionText2>
              <CaptionText2>
                Customer Phone: <NormalText>{itemEditor.phone ? itemEditor.phone.includes("+1") ? itemEditor.phone : `+1 ${itemEditor.phone}` : ""}</NormalText>
              </CaptionText2>
            </DarkSection>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={open5} onClose={handleClose5} PaperProps={{
        sx: {
          width: 'min(1480px, 98vw)',
          maxWidth: 'none',
          borderRadius: '20px',
          overflow: 'hidden',
          background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          boxShadow: '0 20px 55px rgba(15, 23, 42, 0.16)',
        },
      }}>
        <DialogTitle sx={{ padding: 0 }}>
          <div style={{
            padding: '18px 24px',
            background: 'linear-gradient(135deg, #eff6ff 0%, #ffffff 48%, #e0f2fe 100%)',
            color: '#0f172a',
            borderBottom: '1px solid #dbeafe',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 18, alignItems: 'flex-start', flexWrap: 'wrap' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                  <span style={{
                    width: 34,
                    height: 34,
                    borderRadius: 12,
                    background: '#dbeafe',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#2563eb',
                  }}>
                    <Icon sx={{ fontSize: 20 }}>local_shipping</Icon>
                  </span>
                  <span style={{ fontSize: 20, fontWeight: 650, letterSpacing: '-0.02em' }}>Fulfil Order</span>
                </div>
                <div style={{ color: '#64748b', fontSize: 13, fontWeight: 400 }}>
                  Chọn xưởng, kiểm tra item và chọn variant trước khi gửi fulfil.
                </div>
              </div>
              <div style={{
                display: 'flex',
                gap: 10,
                flexWrap: 'wrap',
                justifyContent: 'flex-end',
                fontSize: 12,
              }}>
                <span style={{
                  padding: '8px 12px',
                  borderRadius: 999,
                  background: '#ffffff',
                  color: '#475569',
                  border: '1px solid #dbeafe',
                }}>
                  Order: <strong style={{ color: '#1d4ed8', fontWeight: 650 }}>{itemEditor.order_id}</strong>
                </span>
                <span style={{
                  padding: '8px 12px',
                  borderRadius: 999,
                  background: '#ffffff',
                  color: '#475569',
                  border: '1px solid #dbeafe',
                }}>
                  Customer: <strong style={{ color: '#1d4ed8', fontWeight: 650 }}>{itemEditor.customer_name || 'N/A'}</strong>
                </span>
              </div>
            </div>
          </div>
        </DialogTitle>
        <DialogContent sx={{ padding: '18px 22px 24px !important' }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch", width: "100%", gap: 16 }}>
            <div style={{
              display: "flex",
              flexDirection: "row",
              gap: 8,
              flexWrap: 'wrap',
              padding: 8,
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 16,
            }}>
              {ffSite.map(items => (
                <button
                  disabled={items == "Printify" || items == "Burgershop" || items == "Printway"}
                  key={items}
                  onClick={() => {
                    setFf(items)
                    setSelectedItems([])
                    setLuxuryProSel({})
                    setMerchizeSel({})
                    setAnprintSel({})
                    setFlashshipSel({})
                    setFlashshipPicks({})
                    setLegacyVariantPicks({})
                    setBurgerprintsSel({})
                    setA2kSel({})
                  }}
                  style={{
                    padding: '9px 16px',
                    fontSize: '0.8125rem',
                    fontWeight: 600,
                    borderRadius: '12px',
                    border: items === ff ? '1px solid rgba(37, 99, 235, 0.35)' : '1px solid transparent',
                    cursor: items == "Printify" || items == "Burgershop" || items == "Printway" ? 'not-allowed' : 'pointer',
                    opacity: items == "Printify" || items == "Burgershop" || items == "Printway" ? 0.45 : 1,
                    background: items === ff
                      ? '#ffffff'
                      : 'transparent',
                    color: items === ff ? '#1d4ed8' : '#475569',
                    boxShadow: items === ff ? '0 6px 14px rgba(37, 99, 235, 0.12)' : 'none',
                    transition: 'all 160ms ease',
                  }}
                >
                  {items}
                </button>
              ))}
            </div>
            <div style={{
              width: '100%',
              maxHeight: '62vh',
              overflowY: 'auto',
              overflowX: 'hidden',
              border: '1px solid #e2e8f0',
              borderRadius: 18,
              background: '#ffffff',
              boxShadow: '0 12px 30px rgba(15, 23, 42, 0.08)',
            }}>
              {data.data && data.data.length ? (
                <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'separate', borderSpacing: 0 }}>
                  <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                    <tr>
                      <th style={{ width: 70, textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Select</th>
                      <th style={{ width: '22%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Item Name</th>
                      <th style={{ width: '18%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Options</th>
                      {ff === 'LuxuryPro' ? (
                        <th style={{ width: '42%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>LuxuryPro Catalog</th>
                      ) : null}
                      {ff === 'Merchize' ? (
                        <th style={{ width: '42%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Merchize Catalog</th>
                      ) : null}
                      {ff === 'Anprint' ? (
                        <th style={{ width: '42%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Anprint Catalog</th>
                      ) : null}
                      {ff === 'Flashship' ? (
                        <th style={{ width: '42%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Flashship Variant</th>
                      ) : null}
                      {ff === 'BurgerPrints' ? (
                        <th style={{ width: '42%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>BurgerPrints Catalog</th>
                      ) : null}
                      {ff === 'A2K' ? (
                        <th style={{ width: '42%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>A2K Catalog</th>
                      ) : null}
                      {isLegacyVariantFactory(ff) ? (
                        <th style={{ width: '42%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{ff} Variant</th>
                      ) : null}
                      <th style={{ width: '18%', textAlign: 'left', padding: '14px 12px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: 11, fontWeight: 650, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Images</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.data.filter(item => item.order_id === itemEditor.order_id && !item.status_fulfil).map(item => (
                      <tr key={item.id}>
                        <td style={{ padding: '14px 12px', width: 70, borderBottom: '1px solid #f1f5f9', verticalAlign: 'top' }}>
                          <label style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', margin: 0 }}>
                            <input
                              type="checkbox"
                              checked={!!selectedItems[item.id]}
                              value={item.id}
                              onChange={handleCheckboxChange(item)}
                              style={{
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer',
                                accentColor: '#2563eb'
                              }}
                            />
                          </label>
                        </td>
                        <td style={{ padding: '14px 12px', width: '22%', maxWidth: 0, borderBottom: '1px solid #f1f5f9', verticalAlign: 'top', wordBreak: 'break-word' }}>
                          <div style={{ fontWeight: 500, color: '#0f172a', fontSize: 13, lineHeight: 1.45 }}>{item.items_name}</div>
                          <div style={{ marginTop: 5, color: '#64748b', fontSize: 11, fontWeight: 400 }}>{item.sku}</div>
                        </td>
                        <td style={{ padding: '14px 12px', width: '18%', maxWidth: 0, borderBottom: '1px solid #f1f5f9', verticalAlign: 'top', wordBreak: 'break-word' }}>
                          <div style={{
                            display: 'inline-flex',
                            flexWrap: 'wrap',
                            gap: 6,
                            alignItems: 'center',
                            padding: '7px 9px',
                            borderRadius: 10,
                            background: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            color: '#334155',
                            fontSize: 12,
                            fontWeight: 400,
                            lineHeight: 1.35,
                          }}>
                            <SizeHtml value={item.size} />
                            <span style={{ color: '#94a3b8' }}>•</span>
                            <span style={{ color: '#dc2626', fontWeight: 600 }}>{item.color}</span>
                          </div>
                        </td>
                        {ff === 'LuxuryPro' ? (
                          <td style={{ padding: '14px 12px', width: '42%', maxWidth: 0, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>
                            {selectedItems[item.id] ? (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 14, borderRadius: 14, background: '#ffffff', border: '1px solid #e2e8f0' }}>
                                <LuxuryProCatalogPicker
                                  catalogs={luxurypro}
                                  valueId={luxuryProSel[item.id]?.catalogId}
                                  onChange={(catalogId) => handleLuxuryProCatalogChange(item, catalogId)}
                                />
                                {luxuryProSel[item.id]?.catalogId ? (
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-start' }}>
                                    {(luxurypro.find((c) => String(c.id) === String(luxuryProSel[item.id].catalogId))?.options || [])
                                      .filter((opt) => (opt.values?.length || 0) > 1)
                                      .map((opt) => (
                                        <LuxuryProOptionPicker
                                          key={opt.option}
                                          optionKey={opt.option}
                                          values={opt.values}
                                          value={luxuryProSel[item.id]?.picks?.[opt.option] || ''}
                                          onChange={(v) => handleLuxuryProOptionChange(item, opt.option, v)}
                                        />
                                      ))}
                                  </div>
                                ) : null}
                                {luxuryProSel[item.id]?.catalogSku ? (
                                  <div style={{ fontSize: 11, color: luxuryProSel[item.id]?.variant_id ? '#15803d' : '#c62828', fontWeight: 500 }}>
                                    <div><strong>SKU:</strong> {luxuryProSel[item.id].catalogSku}</div>
                                    <div><strong>variant_id:</strong> {luxuryProSel[item.id].variant_id || '(chưa match — chọn options)'}</div>
                                    {!luxuryProSel[item.id].variant_id && luxuryProSel[item.id].orderSize ? (
                                      <div style={{ color: '#666' }}>Order: {luxuryProSel[item.id].orderSize} / {luxuryProSel[item.id].orderColor}</div>
                                    ) : null}
                                    <div style={{ marginTop: 6, color: '#1565c0' }}>
                                      <strong>Note:</strong>{' '}
                                      {previewLuxuryProNote([item]) || <span style={{ color: '#999' }}>(trống)</span>}
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{ fontSize: 11, marginTop: 6, color: '#1565c0' }}>
                                    <strong>Note:</strong>{' '}
                                    {previewLuxuryProNote([item]) || <span style={{ color: '#999' }}>(trống)</span>}
                                  </div>
                                )}
                              </div>
                            ) : null}
                          </td>
                        ) : null}
                        {ff === 'Merchize' ? (
                          <td style={{ padding: '14px 12px', width: '42%', maxWidth: 0, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>
                            {selectedItems[item.id] ? (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 14, borderRadius: 14, background: '#ffffff', border: '1px solid #e2e8f0' }}>
                                <LuxuryProCatalogPicker
                                  catalogs={merchize}
                                  valueId={merchizeSel[item.id]?.catalogId}
                                  onChange={(catalogId) => handleMerchizeCatalogChange(item, catalogId)}
                                />
                                {merchizeSel[item.id]?.catalogId ? (
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-start' }}>
                                    {(merchize.find((c) => String(c.id) === String(merchizeSel[item.id].catalogId))?.options || [])
                                      .filter((opt) => (opt.values?.length || 0) > 1)
                                      .map((opt) => (
                                        <LuxuryProOptionPicker
                                          key={opt.option}
                                          optionKey={opt.option}
                                          values={opt.values}
                                          value={merchizeSel[item.id]?.picks?.[opt.option] || ''}
                                          onChange={(v) => handleMerchizeOptionChange(item, opt.option, v)}
                                        />
                                      ))}
                                  </div>
                                ) : null}
                                {merchizeSel[item.id]?.catalogSku ? (
                                  <div style={{ fontSize: 11, color: merchizeSel[item.id]?.merchize_sku ? '#15803d' : '#c62828', fontWeight: 500 }}>
                                    <div><strong>SKU:</strong> {merchizeSel[item.id].merchize_sku || merchizeSel[item.id].catalogSku}</div>
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </td>
                        ) : null}
                        {ff === 'Anprint' ? (
                          <td style={{ padding: '14px 12px', width: '42%', maxWidth: 0, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>
                            {selectedItems[item.id] ? (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 14, borderRadius: 14, background: '#ffffff', border: '1px solid #e2e8f0' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                                  <label style={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>Catalog</label>
                                  <AnprintCatalogPicker
                                    catalogs={anprint}
                                    valueId={anprintSel[item.id]?.catalogId}
                                    onChange={(catalogId) => handleAnprintCatalogChange(item, catalogId)}
                                  />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                                  <label style={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>SKU (chọn tay nếu chưa auto-map)</label>
                                  <AnprintVariantPicker
                                    variants={anprintVariants}
                                    valueSku={anprintSel[item.id]?.sku}
                                    onChange={(variant) => handleAnprintVariantChange(item, variant)}
                                  />
                                </div>
                                {anprintSel[item.id]?.catalogId ? (
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-start' }}>
                                    {(anprint.find((c) => String(c.id) === String(anprintSel[item.id].catalogId))?.options || [])
                                      .filter((opt) => (opt.values?.length || 0) > 1)
                                      .map((opt) => (
                                        <LuxuryProOptionPicker
                                          key={opt.option}
                                          optionKey={opt.option}
                                          values={opt.values}
                                          value={anprintSel[item.id]?.picks?.[opt.option] || ''}
                                          onChange={(v) => handleAnprintOptionChange(item, opt.option, v)}
                                        />
                                      ))}
                                  </div>
                                ) : null}
                                {anprintSel[item.id]?.catalogId ? (
                                  <div style={{ fontSize: 11, color: anprintSel[item.id]?.sku ? '#15803d' : '#c62828', fontWeight: 500 }}>
                                    <div><strong>Variant SKU:</strong> {anprintSel[item.id].sku || '(chưa match size/color Anprint)'}</div>
                                    <div style={{ color: '#64748b' }}>
                                      Map Anprint: {anprintSel[item.id].picks?.size || '—'} / {anprintSel[item.id].picks?.color || '—'}
                                      {anprintSel[item.id].orderSize || anprintSel[item.id].orderColor ? (
                                        <span> ← order {anprintSel[item.id].orderSize || '?'} / {anprintSel[item.id].orderColor || '?'}</span>
                                      ) : null}
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{ fontSize: 11, color: '#64748b' }}>
                                    Chưa auto-map — chọn catalog hoặc gõ SKU (giống Merchfox)
                                  </div>
                                )}
                              </div>
                            ) : null}
                          </td>
                        ) : null}
                        {ff === 'BurgerPrints' ? (
                          <td style={{ padding: '14px 12px', width: '42%', maxWidth: 0, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>
                            {selectedItems[item.id] ? (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 14, borderRadius: 14, background: '#ffffff', border: '1px solid #e2e8f0' }}>
                                <LuxuryProCatalogPicker
                                  catalogs={burgerprintsProducts}
                                  valueId={burgerprintsSel[item.id]?.shortCode}
                                  onChange={(shortCode) => handleBurgerprintsCatalogChange(item, shortCode)}
                                />
                                {burgerprintsSel[item.id]?.shortCode ? (
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-start' }}>
                                    <LuxuryProOptionPicker
                                      optionKey="size"
                                      values={burgerprintsDetails[burgerprintsSel[item.id].shortCode]?.sizes || []}
                                      value={burgerprintsSel[item.id]?.size || ''}
                                      onChange={(value) => handleBurgerprintsOptionChange(item, 'size', value)}
                                    />
                                    <LuxuryProOptionPicker
                                      optionKey="color"
                                      values={colorsForSize(
                                        burgerprintsDetails[burgerprintsSel[item.id].shortCode]?.variants || [],
                                        burgerprintsSel[item.id]?.size
                                      )}
                                      value={burgerprintsSel[item.id]?.color || ''}
                                      onChange={(value) => handleBurgerprintsOptionChange(item, 'color', value)}
                                    />
                                  </div>
                                ) : null}
                                {burgerprintsSel[item.id]?.shortCode ? (
                                  <div style={{ fontSize: 11, color: burgerprintsSel[item.id]?.sku ? '#15803d' : '#c62828', fontWeight: 500 }}>
                                    <div><strong>SKU:</strong> {burgerprintsSel[item.id].sku || '(chưa khớp size/color)'}</div>
                                    {burgerprintsSel[item.id].price ? <div><strong>Price:</strong> ${burgerprintsSel[item.id].price}</div> : null}
                                  </div>
                                ) : (
                                  <div style={{ fontSize: 11, color: '#64748b' }}>Chọn catalog BurgerPrints, size và color</div>
                                )}
                              </div>
                            ) : null}
                          </td>
                        ) : null}
                        {ff === 'A2K' ? (
                          <td style={{ padding: '14px 12px', width: '42%', maxWidth: 0, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>
                            {selectedItems[item.id] ? (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 14, borderRadius: 14, background: '#ffffff', border: '1px solid #e2e8f0' }}>
                                <LuxuryProCatalogPicker
                                  catalogs={a2kProducts}
                                  valueId={a2kSel[item.id]?.productCode}
                                  onChange={(productCode) => handleA2kCatalogChange(item, productCode)}
                                />
                                {a2kSel[item.id]?.productCode ? (
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-start' }}>
                                    <LuxuryProOptionPicker
                                      optionKey="size"
                                      values={a2kDetails[a2kSel[item.id].productCode]?.sizes || []}
                                      value={a2kSel[item.id]?.size || ''}
                                      onChange={(value) => handleA2kOptionChange(item, 'size', value)}
                                    />
                                    <LuxuryProOptionPicker
                                      optionKey="color"
                                      values={colorsForSize(
                                        a2kDetails[a2kSel[item.id].productCode]?.variants || [],
                                        a2kSel[item.id]?.size
                                      )}
                                      value={a2kSel[item.id]?.color || ''}
                                      onChange={(value) => handleA2kOptionChange(item, 'color', value)}
                                    />
                                  </div>
                                ) : null}
                                {a2kSel[item.id]?.productCode ? (
                                  <div style={{ fontSize: 11, color: a2kSel[item.id]?.sku ? '#15803d' : '#c62828', fontWeight: 500 }}>
                                    <div><strong>SKU:</strong> {a2kSel[item.id].sku || '(chưa khớp size/color)'}</div>
                                    <div><strong>Print:</strong> {a2kSel[item.id].printTech || 'DTG Print'}</div>
                                    {a2kSel[item.id].price ? <div><strong>Price:</strong> ${a2kSel[item.id].price}</div> : null}
                                  </div>
                                ) : (
                                  <div style={{ fontSize: 11, color: '#64748b' }}>Chưa auto-match — chọn catalog A2K, size và color</div>
                                )}
                              </div>
                            ) : null}
                          </td>
                        ) : null}
                        {ff === 'Flashship' ? (
                          <td style={{ padding: '14px 12px', width: '42%', maxWidth: 0, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>
                            {selectedItems[item.id] ? (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 14, borderRadius: 14, background: '#ffffff', border: '1px solid #e2e8f0' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                                  {flashshipOptionKeys.map(({ key, label }) => (
                                    <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 5, width: key === 'product_type' ? 180 : key === 'color' ? 160 : 140, maxWidth: '100%' }}>
                                      <label style={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>{label}</label>
                                      <select
                                        value={flashshipPicks[item.id]?.[key] || ''}
                                        onChange={(e) => handleFlashshipOptionChange(item, key, e.target.value)}
                                        disabled={!flashshipVariants.length}
                                        style={{
                                          width: '100%',
                                          padding: '9px 11px',
                                          border: '1px solid #cbd5e1',
                                          borderRadius: 10,
                                          fontSize: 12,
                                          color: '#0f172a',
                                          background: '#fff',
                                          outline: 'none',
                                        }}
                                      >
                                        <option value="">{flashshipVariants.length ? `Chọn ${label}` : 'Chưa có data'}</option>
                                        {getFlashshipOptions(item, key).map((value) => (
                                          <option key={value} value={value}>{value}</option>
                                        ))}
                                      </select>
                                    </div>
                                  ))}
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: 170, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>Print Type</label>
                                    <select
                                      value={flashshipPicks[item.id]?.printType || FLASHSHIP_DEFAULT_PRINT_TYPE}
                                      onChange={(e) => handleFlashshipPrintTypeChange(item, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '9px 11px',
                                        border: '1px solid #cbd5e1',
                                        borderRadius: 10,
                                        fontSize: 12,
                                        color: '#0f172a',
                                        background: '#fff',
                                        outline: 'none',
                                      }}
                                    >
                                      {flashshipPrintTypeOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                          {option.value}: {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div style={{ fontSize: 11, color: '#64748b', fontWeight: 400 }}>
                                  {flashshipSel[item.id]
                                    ? <span style={{ color: '#2e7d32' }}><strong>variant_id:</strong> {flashshipSel[item.id]} / <strong>printType:</strong> {flashshipPicks[item.id]?.printType || FLASHSHIP_DEFAULT_PRINT_TYPE}</span>
                                    : flashshipVariants.length
                                      ? 'Chọn đủ 5 dropdown để ra variant_id'
                                      : 'Chạy scripts/fetch-flashship-variants.js để tải data'}
                                </div>
                              </div>
                            ) : null}
                          </td>
                        ) : null}
                        {isLegacyVariantFactory(ff) ? (
                          <td style={{ padding: '14px 12px', width: '42%', maxWidth: 0, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>
                            {selectedItems[item.id] ? (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 14, borderRadius: 14, background: '#ffffff', border: '1px solid #e2e8f0' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: 360, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>Product</label>
                                    {ff === "Merchfox" ? (
                                      <Autocomplete
                                        size="small"
                                        options={getLegacyCatalog(ff)}
                                        value={getLegacyProduct(ff, legacyVariantPicks[item.id]?.productIndex)}
                                        onChange={(_, product) => handleLegacyVariantChange(item, 'productIndex', getLegacyProductIndex(ff, product))}
                                        getOptionLabel={(product) => getLegacyProductLabel(product)}
                                        isOptionEqualToValue={(a, b) => String(a?.id || '') === String(b?.id || '')}
                                        filterOptions={(options, state) => {
                                          const q = String(state.inputValue || '').trim().toLowerCase();
                                          if (!q) return options;
                                          return options.filter((product) => {
                                            const label = getLegacyProductLabel(product).toLowerCase();
                                            return label.includes(q) || String(product.id || '').toLowerCase().includes(q);
                                          });
                                        }}
                                        noOptionsText="Không có product"
                                        ListboxProps={{ style: { maxHeight: 280 } }}
                                        renderInput={(params) => (
                                          <TextField {...params} placeholder={`Gõ để tìm ${getLegacyCatalog(ff).length} product...`} />
                                        )}
                                        sx={{
                                          width: '100%',
                                          '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12, background: '#fff' },
                                        }}
                                      />
                                    ) : (
                                      <select
                                        value={legacyVariantPicks[item.id]?.productIndex || ''}
                                        onChange={(e) => handleLegacyVariantChange(item, 'productIndex', e.target.value)}
                                        style={{
                                          width: '100%',
                                          padding: '9px 11px',
                                          border: '1px solid #cbd5e1',
                                          borderRadius: 10,
                                          fontSize: 12,
                                          color: '#0f172a',
                                          background: '#fff',
                                          outline: 'none',
                                        }}
                                      >
                                        <option value="">Chọn Product</option>
                                        {getLegacyCatalog(ff).map((product, index) => (
                                          <option key={`${getLegacyProductLabel(product)}-${index}`} value={String(index)}>
                                            {getLegacyProductLabel(product)}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                  </div>
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: 160, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>Size</label>
                                    {ff === "Merchfox" ? (
                                      <Autocomplete
                                        size="small"
                                        disabled={!legacyVariantPicks[item.id]?.productIndex}
                                        options={getLegacyProductSizes(ff, getLegacyProduct(ff, legacyVariantPicks[item.id]?.productIndex))}
                                        value={legacyVariantPicks[item.id]?.size || null}
                                        onChange={(_, value) => handleLegacyVariantChange(item, 'size', value || '')}
                                        noOptionsText="Không có size"
                                        renderInput={(params) => (
                                          <TextField {...params} placeholder="Gõ size..." />
                                        )}
                                        sx={{
                                          width: '100%',
                                          '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12, background: '#fff' },
                                        }}
                                      />
                                    ) : (
                                      <select
                                        value={legacyVariantPicks[item.id]?.size || ''}
                                        onChange={(e) => handleLegacyVariantChange(item, 'size', e.target.value)}
                                        disabled={!legacyVariantPicks[item.id]?.productIndex}
                                        style={{
                                          width: '100%',
                                          padding: '9px 11px',
                                          border: '1px solid #cbd5e1',
                                          borderRadius: 10,
                                          fontSize: 12,
                                          color: '#0f172a',
                                          background: '#fff',
                                          outline: 'none',
                                        }}
                                      >
                                        <option value="">Chọn Size</option>
                                        {getLegacyProductSizes(ff, getLegacyProduct(ff, legacyVariantPicks[item.id]?.productIndex)).map((value) => (
                                          <option key={value} value={value}>{value}</option>
                                        ))}
                                      </select>
                                    )}
                                  </div>
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: 200, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>Color</label>
                                    {ff === "Merchfox" ? (
                                      <Autocomplete
                                        size="small"
                                        disabled={!legacyVariantPicks[item.id]?.productIndex || !legacyVariantPicks[item.id]?.size}
                                        options={getLegacyProductColors(
                                          ff,
                                          getLegacyProduct(ff, legacyVariantPicks[item.id]?.productIndex),
                                          legacyVariantPicks[item.id]?.size
                                        )}
                                        value={legacyVariantPicks[item.id]?.color || null}
                                        onChange={(_, value) => handleLegacyVariantChange(item, 'color', value || '')}
                                        noOptionsText="Không có color"
                                        renderInput={(params) => (
                                          <TextField {...params} placeholder="Gõ color..." />
                                        )}
                                        sx={{
                                          width: '100%',
                                          '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12, background: '#fff' },
                                        }}
                                      />
                                    ) : (
                                      <select
                                        value={legacyVariantPicks[item.id]?.color || ''}
                                        onChange={(e) => handleLegacyVariantChange(item, 'color', e.target.value)}
                                        disabled={!legacyVariantPicks[item.id]?.productIndex || !legacyVariantPicks[item.id]?.size}
                                        style={{
                                          width: '100%',
                                          padding: '9px 11px',
                                          border: '1px solid #cbd5e1',
                                          borderRadius: 10,
                                          fontSize: 12,
                                          color: '#0f172a',
                                          background: '#fff',
                                          outline: 'none',
                                        }}
                                      >
                                        <option value="">Chọn Color</option>
                                        {getLegacyProductColors(
                                          ff,
                                          getLegacyProduct(ff, legacyVariantPicks[item.id]?.productIndex),
                                          legacyVariantPicks[item.id]?.size
                                        ).map((value) => (
                                          <option key={value} value={value}>{value}</option>
                                        ))}
                                      </select>
                                    )}
                                  </div>
                                </div>
                                <div style={{ fontSize: 11, fontWeight: 500, color: selectedItems[item.id]?.sku || selectedItems[item.id]?.id ? '#15803d' : '#c62828' }}>
                                  {selectedItems[item.id]?.sku || selectedItems[item.id]?.id ? (
                                    <>
                                      {selectedItems[item.id]?.sku ? <div><strong>SKU:</strong> {selectedItems[item.id].sku}</div> : null}
                                      {selectedItems[item.id]?.id ? <div><strong>ID:</strong> {selectedItems[item.id].id}</div> : null}
                                    </>
                                  ) : 'Chọn đủ Product / Size / Color để ra variant'}
                                </div>
                              </div>
                            ) : null}
                          </td>
                        ) : null}
                        <td style={{ padding: '14px 12px', width: '18%', maxWidth: 0, display: "flex", flexDirection: "row", alignItems: "center", flexWrap: 'wrap', gap: 8, borderBottom: '1px solid #f1f5f9' }}>
                          <span className="caption-text" style={{ fontSize: "10px", color: '#64748b', fontWeight: 600, textTransform: 'uppercase' }}>Mockup</span>
                          <a href={modifyUrlString(item?.images)}><img src={modifyUrlString(item?.images)} style={{ height: '70px', borderRadius: 12, border: '1px solid #e2e8f0', background: '#fff', padding: 4, boxShadow: '0 6px 16px rgba(15, 23, 42, 0.08)' }} alt="Mockup" /></a>
                          {hasFulfillDesign(item, 'front') ? renderFulfillDesignThumb(item, 'front') : null}
                          {hasFulfillDesign(item, 'back') ? renderFulfillDesignThumb(item, 'back') : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : null}
            </div>

            {ff === 'LuxuryPro' && Object.values(selectedItems).some((items) => items != undefined) ? (
              <TextField
                label="Note gửi LuxuryPro"
                multiline
                minRows={2}
                fullWidth
                sx={{
                  marginTop: 1,
                  maxWidth: 760,
                  alignSelf: 'center',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '14px',
                    background: '#fff',
                  },
                }}
                value={previewLuxuryProNote(
                  (data.data || [])
                    .filter((item) => item.order_id === itemEditor.order_id && !item.status_fulfil && selectedItems[item.id])
                    .map((item) => ({ items: [item] }))
                )}
                InputProps={{ readOnly: true }}
                placeholder="(không có custom trong size)"
              />
            ) : null}

            {Object.values(selectedItems).length > 0 && Object.values(selectedItems).filter(items => items != undefined) != 0 ?
              <button
                onClick={handleFulFil}
                style={{
                  alignSelf: 'center',
                  marginTop: '2px',
                  padding: '12px 28px',
                  fontSize: '0.9rem',
                  fontWeight: 650,
                  borderRadius: '14px',
                  border: 'none',
                  cursor: 'pointer',
                  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                  color: '#fff',
                  boxShadow: '0 12px 24px rgba(37, 99, 235, 0.22)',
                  letterSpacing: '0.01em',
                }}
              >
                Fulfil Selected
              </button> : null}
          </div>
        </DialogContent>
        <DialogActions>

        </DialogActions>
      </Dialog>
      <Dialog
        open={open6}
        onClose={handleClose6}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '22px',
            overflow: 'hidden',
            background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
            boxShadow: '0 20px 55px rgba(15, 23, 42, 0.16)',
          },
        }}
      >
        <DialogTitle sx={{ padding: 0 }}>
          <div style={{
            padding: '18px 24px',
            background: 'linear-gradient(135deg, #eff6ff 0%, #ffffff 48%, #e0f2fe 100%)',
            borderBottom: '1px solid #dbeafe',
          }}>
            <div style={{ fontSize: 20, fontWeight: 650, letterSpacing: '-0.02em', color: '#0f172a' }}>
              Edit Size & Color
            </div>
            <div style={{ marginTop: 6, color: '#64748b', fontSize: 13, fontWeight: 400, lineHeight: 1.45 }}>
              {itemEditor.items_name || 'Order item'}
              {itemEditor.order_id ? ` · ${itemEditor.order_id}` : ''}
            </div>
          </div>
        </DialogTitle>
        <DialogContent sx={{ padding: '20px 22px 8px !important' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{
              padding: 14,
              borderRadius: 16,
              background: '#ffffff',
              border: '1px solid #e2e8f0',
            }}>
              <div style={{ fontSize: 10, color: '#64748b', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: 8 }}>
                Size
              </div>
              <textarea
                value={size}
                onChange={(e) => setSize(e.target.value)}
                rows={4}
                placeholder="Type: Unisex - Fabric Brand: Gildan - Style: Unisex T-Shirt - Size: M - Product Sides Options: Both Sides"
                style={{
                  width: '100%',
                  minHeight: 96,
                  resize: 'vertical',
                  border: '1px solid #cbd5e1',
                  borderRadius: 12,
                  padding: '11px 13px',
                  fontSize: 13,
                  lineHeight: 1.5,
                  color: '#0f172a',
                  background: '#f8fafc',
                  outline: 'none',
                  fontFamily: 'inherit',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <div style={{
              padding: 14,
              borderRadius: 16,
              background: '#ffffff',
              border: '1px solid #e2e8f0',
            }}>
              <div style={{ fontSize: 10, color: '#64748b', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: 8 }}>
                Color
              </div>
              <textarea
                value={color}
                onChange={(e) => setColor(e.target.value)}
                rows={3}
                placeholder="Navy"
                style={{
                  width: '100%',
                  minHeight: 72,
                  resize: 'vertical',
                  border: '1px solid #cbd5e1',
                  borderRadius: 12,
                  padding: '11px 13px',
                  fontSize: 13,
                  lineHeight: 1.5,
                  color: '#0f172a',
                  background: '#f8fafc',
                  outline: 'none',
                  fontFamily: 'inherit',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <div style={{
              padding: '12px 14px',
              borderRadius: 14,
              background: '#f8fafc',
              border: '1px dashed #cbd5e1',
            }}>
              <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: 8 }}>
                Preview trên bảng
              </div>
              <div style={{ color: '#475569', fontSize: 13, lineHeight: 1.45, wordBreak: 'break-word' }}>
                {size || '—'}
              </div>
              <span style={{
                display: 'inline-flex',
                marginTop: 8,
                padding: '4px 10px',
                borderRadius: 999,
                background: '#fef2f2',
                color: '#dc2626',
                fontSize: 12,
                fontWeight: 650,
              }}>
                {color?.trim() ? color : 'None'}
              </span>
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ padding: '12px 22px 20px', gap: 8 }}>
          <button
            type="button"
            onClick={handleClose6}
            style={{
              padding: '9px 16px',
              borderRadius: 12,
              border: '1px solid #e2e8f0',
              background: '#ffffff',
              color: '#475569',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => handleChangeVariant2()}
            style={{
              padding: '9px 18px',
              borderRadius: 12,
              border: '1px solid rgba(37, 99, 235, 0.35)',
              background: '#2563eb',
              color: '#ffffff',
              fontSize: 13,
              fontWeight: 650,
              cursor: 'pointer',
              boxShadow: '0 8px 18px rgba(37, 99, 235, 0.22)',
            }}
          >
            Update
          </button>
        </DialogActions>
      </Dialog>
      <Dialog open={open8} onClose={handleClose8}>
        <DialogTitle>Delete Fulfil</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <TextField
              label='Enter "ok" to display the delete button'
              sx={{ margin: "10px", width: 300 }}
              value={clear}
              onChange={(e) => setClear(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          {clear == "ok" ? <Button onClick={() => handleClear()} variant="outline" style={{ color: "green" }}>
            Xoá FF
          </Button> : null}
        </DialogActions>
      </Dialog>

      {/* Bulk Process Dialog */}
      <Dialog open={openBulkDialog} onClose={handleCloseBulkDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Icon sx={{ color: '#1976d2' }}>batch_prediction</Icon>
            <span>Bulk Process Selected Items</span>
          </div>
        </DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginTop: "16px" }}>
            <div>
              <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#666' }}>
                Processing {selectedOrderItems.length} item(s)
              </span>

            </div>

            <TextField
              label="FF (Fulfilment)"
              fullWidth
              value={bulkFF}
              onChange={(e) => setBulkFF(e.target.value)}
              placeholder="Enter FF value (e.g., A-12345)"
              sx={{ marginBottom: 2 }}
              helperText="Enter the fulfilment ID for all selected items"
            />

            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={bulkStatusFulfil}
                onChange={(e) => setBulkStatusFulfil(e.target.checked)}
                style={{
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer',
                  accentColor: '#1976d2'
                }}
              />
              <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                Mark as Status Fulfil
              </span>
            </label>

            <div>
              <span style={{ fontSize: '12px', color: '#666' }}>
                <strong>Note:</strong> This will update all selected items with the same FF value and status fulfil setting.
              </span>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBulkDialog} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleBulkProcess}
            variant="contained"
            color="primary"
            disabled={!bulkFF.trim()}
            startIcon={<Icon>save</Icon>}
          >
            Process Items
          </Button>
        </DialogActions>
      </Dialog>

      {/* Shipping Method Dialog */}
      <Dialog open={openShippingDialog} onClose={handleCloseShippingDialog}>
        <DialogTitle>Edit Shipping Method</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "16px", marginTop: "16px" }}>
            <TextField
              label="Shipping Method"
              sx={{ margin: "10px", width: 300 }}
              value={shippingMethod}
              onChange={(e) => setShippingMethod(e.target.value)}
              placeholder="Enter shipping method"
            />
            <div style={{ display: "flex", flexDirection: "row", gap: "8px", flexWrap: "wrap" }}>
              <button
                onClick={() => setShippingMethod("Standard Shipping")}
                style={{
                  padding: '6px 16px',
                  fontSize: '0.8125rem',
                  fontWeight: 500,
                  borderRadius: '20px',
                  border: 'none',
                  cursor: 'pointer',
                  textTransform: 'none',
                  background: shippingMethod === "Standard Shipping"
                    ? 'linear-gradient(195deg, #4caf50, #43a047)'
                    : 'linear-gradient(195deg, #333, #212121)',
                  color: '#fff'
                }}
              >
                Standard Shipping
              </button>
              <button
                onClick={() => setShippingMethod("Priority Shipping")}
                style={{
                  padding: '6px 16px',
                  fontSize: '0.8125rem',
                  fontWeight: 500,
                  borderRadius: '20px',
                  border: 'none',
                  cursor: 'pointer',
                  textTransform: 'none',
                  background: shippingMethod === "Priority Shipping"
                    ? 'linear-gradient(195deg, #4caf50, #43a047)'
                    : 'linear-gradient(195deg, #333, #212121)',
                  color: '#fff'
                }}
              >
                Priority Shipping
              </button>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseShippingDialog} >
            Cancel
          </Button>
          <Button onClick={handleUpdateShipping}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout >
  );
}

export default Tables;
